export const themeColors = {
  colfactura: {
    tenantLanguage: "es",
    primary: {
      light: "#50CBFF",
      main: "#025BA5",
      dark: "#025BA5",
      iconSend: "#16B1F3",
    },
    secondary: {
      dark: "#E45501",
      main: "#FF0004",
      light: "#FFE5E6",
      titleText: "#025BA5",
    },
    info: {
      light: "#D5D5D5",
      main: "#00000080",
      dark: "#C1C1C1",
    },
    error: {
      light: "#FA5A00",
      main: "#D80000",
      dark: "#D80000",
      secondary: "",
      typographyColor: ""
    },
    background: {
      paper: "#ffffff",   // fondo de las cards
      input: "",
      adornmentPrimary: "",
      selectColorDefault: "#E6FFEF",
      selectUsersCertificates: "",
      adornmentSecondary: "",
      certificateButtonColor: "",
      selectIcon: "#007C2F",
      disabledButtonColor: "",
      backButtonColor: "",
      codeInputBorderColor: "",
      hr:""
    },
    letter: {
      color: "",
      disabledColor: "",
      typographyColor: "",
      codeInputTypographyColor: ""
    },
    logoSettings: {
      widthResendEmail: "",
      heightResendEmail: "",
      marginLeftResendEmail: "",
      widthResetPwd: "",
      heightAlertResetPassword: "",
      heightResetPassword: "",
      marginLeftResetPassword: "",
      widthImage: "",
    },
    urlLogo: {
      url: "",
      urlSignIn: "colfacturaLogo.png",
      urlRememberPasswordlogo: "",
      urlChangePasswordlogo: "",
      urlActivatePasswordlogo: "",
      urlCheckEmaillogo: "",
      urlCheckEmailMoreBlue: "",
      urlInvalidLinkMoreBlue: "",
      urlRemeberAndInvalid: "",
      urlExpireTime: "",
      urlSuccessAlertlogo: "",
      urlSuccessAccountActivated:"",
      urlCheckEmailAgain: "",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
      urlPasswordResetLogo: "",
      urlResendEmailLogo: "",
      urlAlert: "",
    },
    InputUko: {
      colorInputLetter: "",
      borderInput: "",
      colorLabel: "",
      colorLabelFocus: "",
      colorIcon: "",
      backgroundColor: "",
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "#D1E2F0",
      buttonUkoColorDisabled: "#FFFFFF",
      buttonUkoBackgroundActive: "",
      buttonUkoBackgroundSuccess: "",
      buttonUkoColorDisabledResetPwd: "",
    },
    linkUko: {
      colorLink: "",
    },
    typographyMessageUko: {
      textColor: '',
    },
    versionUko: {
      colorVersionLabel: ""
    },
    alertUko: {
      imageUko: "",
      colorTextUko: "",
    },
    forgotPassword: {
      colorForgotPwd: "",
    },
    typographyText:{
      textColor: "",
      pathColor: ""
    },
    selectAccount: {
      colorRoot: "",
      colorChecked: "",
    },
    widthImageLogo: "150px",
    colorLoading:"#025BA5",
    errorBox: {
      color: "",
      backgroundColor: "",
    },
    statusLicense: {
      containerMessage: {
        backgroundColor: "",
      },
    },
    alertPopup: {
      iconClose: {
        color: "",
      },
      titleAlert: {
        color: "",
      },
      buttonCancel: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      buttonAccept: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      secondaryMessageText: {
        color: "",
      },
      mensajeModalMain: {},
    },
    iconColorError: {
      bgColorCards: {},
      appBgColorCards: {
        boxShadow: "",
      },
      rootCard: {},
      title: {
        color: "",
      },
      subtitle: {
        color: "",
      },
      cardHeader: {
        color: "",
      },
      featureName: {},
      featureValue: {
        color: "",
      },
      buttonCard: {
        backgroundColor: "",
        color: "",
      },
      hoverButtonCard: {
        color: "",
        backgroundColor: "",
      },
      iconCard: {
        color: "",
      },
      btnDirectPlan: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      circularColor: {
        color: "",
      },
      tablePlanTable: {
        color: "",
        backgroundColor: "",
        fontWeight: "",
      },
      tableCellPlanTable: {
        color: "",
        backgroundColor: "",
      },
      purchasedPlans: {
        color: "",
        fontWeight: "",
      },
      plansTypography: {
        color: "",
        marginLeft: 0,
      },
      spanPlanTable: {
        color: "",
      },
      reportIcon: {
        color: "",
      },
    },
    passwordCheckColor:{
      borderInput: ""
    }
  },
  colnomina: {
    tenantLanguage: "es",
    primary: {
      light: "#50CBFF",
      main: "#025BA5",
      dark: "#025BA5",
      iconSend: "#16B1F3",
    },
    secondary: {
      dark: "#E45501",
      main: "#FF0004",
      light: "#FFE5E6",
      titleText: "#025BA5",
    },
    info: {
      light: "#D5D5D5",
      main: "#00000080",
      dark: "#C1C1C1",
    },
    error: {
      light: "#FA5A00",
      main: "#D80000",
      dark: "#D80000",
      secondary: "",
      typographyColor: ""
    },
    background: {
      paper: "#ffffff",   // fondo de las cards
      input: "",
      adornmentPrimary: "",
      selectColorDefault: "#E6FFEF",
      selectUsersCertificates: "",
      adornmentSecondary: "",
      certificateButtonColor: "",
      selectIcon: "#007C2F",
      disabledButtonColor: "",
      backButtonColor: "",
      codeInputBorderColor: "",
      hr:""
    },
    letter: {
      color: "",
      disabledColor: "",
      typographyColor: "",
      codeInputTypographyColor: ""
    },
    logoSettings: {
      widthResendEmail: "",
      heightResendEmail: "",
      marginLeftResendEmail: "",
      widthResetPwd: "",
      heightAlertResetPassword: "",
      heightResetPassword: "",
      marginLeftResetPassword: "",
      widthImage: "",
    },
    urlLogo: {
      url: "",
      urlSignIn: "colnominaLogo.png",
      urlRememberPasswordlogo: "",
      urlCheckEmaillogo: "",
      urlCheckEmailMoreBlue: "",
      urlInvalidLinkMoreBlue: "",
      urlRemeberAndInvalid: "",
      urlExpireTime: "",
      urlChangePasswordlogo: "",
      urlActivatePasswordlogo: "",
      urlSuccessAlertlogo: "",
      urlSuccessAccountActivated:"",
      urlCheckEmailAgain: "",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
      urlPasswordResetLogo: "",
      urlResendEmailLogo: "",
      urlAlert: "",
    },
    InputUko: {
      colorInputLetter: "",
      borderInput: "",
      colorLabel: "",
      colorLabelFocus: "",
      colorIcon: "",
      backgroundColor: "",
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "#D1E2F0",
      buttonUkoColorDisabled: "#FFFFFF",
      buttonUkoBackgroundActive: "",
      buttonUkoBackgroundSuccess: "",
      buttonUkoColorDisabledResetPwd: "",
    },
    linkUko: {
      colorLink: "",
    },
    typographyMessageUko: {
      textColor: '',
    },
    versionUko: {
      colorVersionLabel: ""
    },
    alertUko: {
      imageUko: "",
      colorTextUko: "",
    },
    forgotPassword: {
      colorForgotPwd: "",
    },
    typographyText:{
      textColor: "",
      pathColor: ""
    },
    selectAccount: {
      colorRoot: "",
      colorChecked: "",
    },
    widthImageLogo: "150px",
    colorLoading:"#50CBFF",
    errorBox: {
      color: "",
      backgroundColor: "",
    },
    statusLicense: {
      containerMessage: {
        backgroundColor: "",
      },
    },
    alertPopup: {
      iconClose: {
        color: "",
      },
      titleAlert: {
        color: "",
      },
      buttonCancel: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      buttonAccept: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      secondaryMessageText: {
        color: "",
      },
      mensajeModalMain: {},
    },
    iconColorError: {
      bgColorCards: {},
      appBgColorCards: {
        boxShadow: "",
      },
      rootCard: {},
      title: {
        color: "",
      },
      subtitle: {
        color: "",
      },
      cardHeader: {
        color: "",
      },
      featureName: {},
      featureValue: {
        color: "",
      },
      buttonCard: {
        backgroundColor: "",
        color: "",
      },
      hoverButtonCard: {
        color: "",
        backgroundColor: "",
      },
      iconCard: {
        color: "",
      },
      btnDirectPlan: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      circularColor: {
        color: "",
      },
      tablePlanTable: {
        color: "",
        backgroundColor: "",
        fontWeight: "",
      },
      tableCellPlanTable: {
        color: "",
        backgroundColor: "",
      },
      purchasedPlans: {
        color: "",
        fontWeight: "",
      },
      plansTypography: {
        color: "",
        marginLeft: 0,
      },
      spanPlanTable: {
        color: "",
      },
      reportIcon: {
        color: "",
      },
    },
    passwordCheckColor:{
      borderInput: ""
    }
  },
  firmaya: {
    tenantLanguage: "es",
    primary: {
      light: "#FFAB8C",
      main: "#FA5A00",
      dark: "#E55200",
      iconSend: "#E55200",
    },
    secondary: {
      dark: "#E45501",
      main: "#FA5A00",
      light: "#FA5A0026",
      titleText: "#025BA5",
    },
    info: {
      light: "#D5D5D5",
      main: "#00000080",
      dark: "#C1C1C1",
    },
    error: {
      light: "#FA5A00",
      main: "#D80000",
      dark: "#D80000",
      secondary: "#D61103",
      typographyColor: ""
    },
    background: {
      paper: "#ffffff",   // fondo de las cards
      input: "#FFFFFF",
      adornmentPrimary: "#F5AE19",
      selectColorDefault: "#575756",
      selectUsersCertificates: "transparent",
      adornmentSecondary: "",
      certificateButtonColor: "#ffffff",
      selectIcon: "#F5AE19",
      disabledButtonColor: "#D87B3C",
      backButtonColor: "#FFFFFF",
      codeInputBorderColor: "",
      hr: "#DADADA",
    },
    letter: {
      color: "#B2B2B2",
      disabledColor: "#FFFFFF",
      typographyColor: "#4F4F4F",
      codeInputTypographyColor: "#575756"
    },
    logoSettings: {
      widthResendEmail: "192px",
      heightResendEmail: "70px",
      marginLeftResendEmail: "104px",
      widthResetPwd: "192px",
      heightAlertResetPassword: "",
      heightResetPassword: "70px",
      marginLeftResetPassword: "auto",
    },
    urlLogo: {
      url: "",
      urlSignIn: "firmayaLogo.png",
      urlRememberPasswordlogo: "",
      urlCheckEmaillogo: "",
      urlCheckEmailMoreBlue: "",
      urlInvalidLinkMoreBlue: "",
      urlRemeberAndInvalid: "",
      urlExpireTime: "",
      urlChangePasswordlogo: "",
      urlActivatePasswordlogo: "",
      urlSuccessAlertlogo: "warningImage.png",
      urlSuccessAccountActivated:"warningImage.png",
      urlCheckEmailAgain: "",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
      urlPasswordResetLogo: "ico_firmaya_password_reset",
      urlResendEmailLogo: "ico_firmaya_resend_email",
      urlAlert: "",
    },
    InputUko: {
      colorInputLetter: "",
      borderInput: "",
      colorLabel: "",
      colorLabelFocus: "",
      colorIcon: "",
      backgroundColor: "",
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "",
      buttonUkoColorDisabled: "",
      buttonUkoBackgroundActive: "",
      buttonUkoBackgroundSuccess: "",
      buttonUkoColorDisabledResetPwd: "",
    },
    linkUko: {
      colorLink: "",
    },
    typographyMessageUko: {
      textColor: '',
    },
    versionUko: {
      colorVersionLabel: ""
    },
    alertUko: {
      imageUko: "",
      colorTextUko: "",
    },
    forgotPassword: {
      colorForgotPwd: "",
    },
    typographyText:{
      textColor: "",
      pathColor: ""
    },
    selectAccount: {
      colorRoot: "",
      colorChecked: "",
    },
    widthImageLogo: "160px",
    colorLoading:"#FA5A00",
    errorBox: {
      color: "#FF0004",
      backgroundColor: "#FFE5E6",
    },
    statusLicense: {
      containerMessage: {
        backgroundColor: "",
      },
    },
    alertPopup: {
      iconClose: {
        color: "",
      },
      titleAlert: {
        color: "",
      },
      buttonCancel: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      buttonAccept: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      secondaryMessageText: {
        color: "",
      },
      mensajeModalMain: {},
    },
    iconColorError: {
      bgColorCards: {},
      appBgColorCards: {
        boxShadow: "",
      },
      rootCard: {},
      title: {
        color: "",
      },
      subtitle: {
        color: "",
      },
      cardHeader: {
        color: "",
      },
      featureName: {},
      featureValue: {
        color: "",
      },
      buttonCard: {
        backgroundColor: "",
        color: "",
      },
      hoverButtonCard: {
        color: "",
        backgroundColor: "",
      },
      iconCard: {
        color: "",
      },
      btnDirectPlan: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      circularColor: {
        color: "",
      },
      tablePlanTable: {
        color: "",
        backgroundColor: "",
        fontWeight: "",
      },
      tableCellPlanTable: {
        color: "",
        backgroundColor: "",
      },
      purchasedPlans: {
        color: "",
        fontWeight: "",
      },
      plansTypography: {
        color: "",
        marginLeft: 0,
      },
      spanPlanTable: {
        color: "",
      },
      reportIcon: {
        color: "",
      },
    },
    passwordCheckColor:{
      borderInput: ""
    }
  },
  firmaya_bmsfirmado: {
    tenantLanguage: "es",
    primary: {
      light: "#293233",
      main: "#09C3D1",
      dark: "#25DFEB",
      iconSend: "#003582",
    },
    secondary: {
      dark: "#E45501",
      main: "#E1FF2B !important",
      light: "#0C0C0C",
      titleText: "#F6F7F9"
    },
    info: {
      light: "#D5D5D5",
      main: "#00000080",
      dark: "#C1C1C1",
      // light: "#EBECF3",
    },
    error: {
      light: "#FEA3B1",
      main: "#FD5674",
      dark: "#FEA3B1",
      secondary: "#FD5674",
      typographyColor: ""
    },
    background: {
      paper: "#141D1E",   // fondo de las cards
      input: "#141D1E",
      adornmentPrimary: "#293233",
      selectColorDefault: "#EDF2F2",
      selectUsersCertificates: "#141D1E",
      adornmentSecondary: "",
      certificateButtonColor: "#141D1E",
      selectIcon: "#EDF2F2",
      disabledButtonColor: "#293233",
      backButtonColor: "#141D1E",
      codeInputBorderColor: "#DAE4E5",
      hr: "#566061",
    }, 
    letter: {
      color: "#DAE4E5",
      disabledColor: "#566061",
      typographyColor: "#EDF2F2", 
      codeInputTypographyColor: "#DAE4E5",
    },
    logoSettings: {
      widthResendEmail: "120px",
      heightResendEmail: "120px",
      marginLeftResendEmail: "100px",
      widthResetPwd: "120px",
      heightAlertResetPassword: "",
      heightResetPassword: "120px",
      marginLeftResetPassword: "102px",
    },
    urlLogo: {
      url: "",
      urlSignIn: "LogosUko/myselfcert/LogoBeMyself.svg",
      urlRememberPasswordlogo: "",
      urlCheckEmaillogo: "",
      urlCheckEmailMoreBlue: "",
      urlInvalidLinkMoreBlue: "",
      urlRemeberAndInvalid: "",
      urlExpireTime: "",
      urlChangePasswordlogo: "",
      urlActivatePasswordlogo: "",
      urlSuccessAlertlogo: "warningImage.png",
      urlSuccessAccountActivated:"warningImage.png",
      urlCheckEmailAgain: "",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
      urlPasswordResetLogo: "ico_firmado_password_reset",
      urlResendEmailLogo: "ico_firmado_resend_email",
      urlAlert: "",
    },
    InputUko: {
      colorInputLetter: "#BEC8C9",
      borderInput: "#6F797A",
      colorLabel: "#BEC8C9",
      colorLabelFocus: "#09C3D1",
      colorIcon: "#B2B3BD",
      backgroundColor: "#0C0C0C"
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "#293233",
      buttonUkoColorDisabled: "#75788A !important",
      buttonUkoBackgroundActive: "#09C3D1",
      buttonUkoBackgroundSuccess: "#141D1E",
      buttonUkoColorDisabledResetPwd: "#3F4849 !important",
    },
    linkUko: {
      colorLink: "#D5F129",
    },
    typographyMessageUko: {
      textColor: '#EBECF3',
    },
    versionUko: {
      colorVersionLabel: "#FCFDFD",
      colorVersionCiamLabel: "#FCFDFD",
    },
    alertUko: {
      imageUko: "",
      colorTextUko: "#ADB3CC",
    },
    forgotPassword: {
      colorForgotPwd: "#E1FF2B",
    },
    typographyText:{
      textColor: "",
      pathColor: ""
    },
    selectAccount: {
      colorRoot: "#09C3D1",
      colorChecked: "#09C3D1",
    },
    widthImageLogo: "168px",
    colorLoading:"#09C3D1",
    errorBox: {
      color: "#FD5674",
      backgroundColor: "#382120",
    },
    statusLicense: {
      containerMessage: {
        backgroundColor: "",
      },
    },
    alertPopup: {
      iconClose: {
        color: "",
      },
      titleAlert: {
        color: "",
      },
      buttonCancel: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      buttonAccept: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      secondaryMessageText: {
        color: "",
      },
      mensajeModalMain: {},
    },
    iconColorError: {
      bgColorCards: {},
      appBgColorCards: {
        boxShadow: "",
      },
      rootCard: {},
      title: {
        color: "",
      },
      subtitle: {
        color: "",
      },
      cardHeader: {
        color: "",
      },
      featureName: {},
      featureValue: {
        color: "",
      },
      buttonCard: {
        backgroundColor: "",
        color: "",
      },
      hoverButtonCard: {
        color: "",
        backgroundColor: "",
      },
      iconCard: {
        color: "",
      },
      btnDirectPlan: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      circularColor: {
        color: "",
      },
      tablePlanTable: {
        color: "",
        backgroundColor: "",
        fontWeight: "",
      },
      tableCellPlanTable: {
        color: "",
        backgroundColor: "",
      },
      purchasedPlans: {
        color: "",
        fontWeight: "",
      },
      plansTypography: {
        color: "",
        marginLeft: 0,
      },
      spanPlanTable: {
        color: "",
      },
      reportIcon: {
        color: "",
      },
    },
    passwordCheckColor:{
      borderInput: "#6F797A"
    }
  },

  ibuhoo: {
    tenantLanguage: "es",
    primary: {
      light: "#009BDD",
      main: "#1D71B8",
      dark: "#003582",
      iconSend: "#003582",
    },
    secondary: {
      dark: "#E45501",
      main: "#FF0004",
      light: "#FFE5E6",
      titleText: "#E55200",
    },
    info: {
      light: "#D5D5D5",
      main: "#00000080",
      dark: "#C1C1C1",
    },
    error: {
      light: "#FA5A00",
      main: "#D80000",
      dark: "#D80000",
      secondary: "",
      typographyColor: ""
    },
    background: {
      paper: "#ffffff",   // fondo de las cards
      input: "",
      adornmentPrimary: "",
      selectColorDefault: "#E6FFEF",
      selectUsersCertificates: "",
      adornmentSecondary: "",
      certificateButtonColor: "",
      selectIcon: "#007C2F",
      disabledButtonColor: "",
      backButtonColor: "",
      codeInputBorderColor: "",
      hr:""
    },
    letter: {
      color: "",
      disabledColor: "",
      typographyColor: "",
      codeInputTypographyColor: ""
    },
    text: {
      primary: "#009BDD",
    },
    logoSettings: {
      widthResendEmail: "",
      heightResendEmail: "",
      marginLeftResendEmail: "",
      widthResetPwd: "",
      heightAlertResetPassword: "",
      heightResetPassword: "",
      marginLeftResetPassword: "",
      widthImage: "",
    },
    urlLogo: {
      url: "",
      urlSignIn: "gseLogo.png",
      urlRememberPasswordlogo: "",
      urlCheckEmaillogo: "",
      urlCheckEmailMoreBlue: "",
      urlInvalidLinkMoreBlue: "",
      urlRemeberAndInvalid: "",
      urlExpireTime: "",
      urlChangePasswordlogo: "",
      urlActivatePasswordlogo: "",
      urlSuccessAlertlogo: "",
      urlSuccessAccountActivated:"",
      urlCheckEmailAgain: "",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
      urlPasswordResetLogo: "",
      urlResendEmailLogo: "",
      urlAlert: "",
    },
    InputUko: {
      colorInputLetter: "",
      borderInput: "",
      colorLabel: "",
      colorLabelFocus: "",
      colorIcon: "",
      backgroundColor: "",
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "#D1E2F0",
      buttonUkoColorDisabled: "#FFFFFF",
      buttonUkoBackgroundActive: "",
      buttonUkoBackgroundSuccess: "",
      buttonUkoColorDisabledResetPwd: "",
    },
    linkUko: {
      colorLink: "",
    },
    typographyMessageUko: {
      textColor: '',
    },
    versionUko: {
      colorVersionLabel: ""
    },
    alertUko: {
      imageUko: "",
      colorTextUko: "",
    },
    forgotPassword: {
      colorForgotPwd: "",
    },
    typographyText:{
      textColor: "",
      pathColor: ""
    },
    selectAccount: {
      colorRoot: "",
      colorChecked: "",
    },
    widthImageLogo: "",
    colorLoading:"",
    errorBox: {
      color: "",
      backgroundColor: "",
    },
    statusLicense: {
      containerMessage: {
        backgroundColor: 'white',
      },
    },
    alertPopup: {
      iconClose: {
        color: '#1D71B8',
      },
      titleAlert: {
        color: '#E45501',
      },
      buttonCancel: {
        backgroundColor: '#1D71B8',
        color: '#fff',
        '&:hover': {
          backgroundColor: '#1D71B8',
        },
      },
      buttonAccept: {
        backgroundColor: '#1D71B8',
        color: '#fff',
        '&:hover': {
          backgroundColor: '#1D71B8',
        },
      },
      secondaryMessageText: {
        color: '#c3c3c3',
      },
      mensajeModalMain: {},
    },
    iconColorError: {
      bgColorCards: {},
      appBgColorCards: {
        boxShadow: 'none',
      },
      rootCard: {},
      title: {
        color: '#1D71B8',
      },
      subtitle: {
        color: '#6D6E72',
      },
      cardHeader: {
        color: '#003582',
      },
      featureName: {},
      featureValue: {
        color: '#009BDD',
      },
      buttonCard: {
        backgroundColor: '#E55200',
        color: '#fff',
      },
      hoverButtonCard: {
        color: '#fff',
        backgroundColor: '#E55200',
      },
      iconCard: {
        color: '#009BDD',
      },
      btnDirectPlan: {
        backgroundColor: '#16B1F3',
        color: '#FFFFFF',
        '&:hover': {
          backgroundColor: '#0f7baa',
        },
      },
      circularColor: {
        color: '#FFFFFF',
      },
      tablePlanTable: {
        color: '#FFFFFF',
        backgroundColor: '#009BDD',
        fontWeight: 700,
      },
      tableCellPlanTable: {
        color: '#000000',
        backgroundColor: '#FFFFFF1C',
      },
      purchasedPlans: {
        color: '#009BDD',
        fontWeight: 700,
      },
      plansTypography: {
        color: '#4F4F4F',
        marginLeft: 0,
      },
      spanPlanTable: {
        color: '#E55200',
      },
      reportIcon: {
        color: '#E55200',
      },
    },
    passwordCheckColor:{
      borderInput: ""
    }
  },
  license: {
    tenantLanguage: "es",
    primary: {
      light: "#009BDD",
      main: "#1D71B8",
      dark: "#003582",
      iconSend: "#003582",
    },
    secondary: {
      dark: "#E45501",
      main: "#FF0004",
      light: "#FFE5E6",
      titleText: "#E55200",
    },
    info: {
      light: "#D5D5D5",
      main: "#00000080",
      dark: "#C1C1C1",
    },
    error: {
      light: "#FA5A00",
      main: "#D80000",
      dark: "#D80000",
      secondary: "",
      typographyColor: ""
    },
    background: {
      paper: "#ffffff",   // fondo de las cards
      input: "",
      adornmentPrimary: "",
      selectColorDefault: "#E6FFEF",
      selectUsersCertificates: "",
      adornmentSecondary: "",
      certificateButtonColor: "",
      selectIcon: "#007C2F",
      disabledButtonColor: "",
      backButtonColor: "",
      codeInputBorderColor: "",
      hr:""
    },
    letter: {
      color: "",
      disabledColor: "",
      typographyColor: "",
      codeInputTypographyColor: ""
    },
    logoSettings: {
      widthResendEmail: "",
      heightResendEmail: "",
      marginLeftResendEmail: "",
      widthResetPwd: "",
      heightAlertResetPassword: "",
      heightResetPassword: "",
      marginLeftResetPassword: "",
      widthImage: "",
    },
    urlLogo: {
      url: "",
      urlSignIn: "gseLogo.png",
      urlRememberPasswordlogo: "",
      urlCheckEmaillogo: "",
      urlCheckEmailMoreBlue: "",
      urlInvalidLinkMoreBlue: "",
      urlRemeberAndInvalid: "",
      urlExpireTime: "",
      urlChangePasswordlogo: "",
      urlActivatePasswordlogo: "",
      urlSuccessAlertlogo: "",
      urlSuccessAccountActivated:"",
      urlCheckEmailAgain: "",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
      urlPasswordResetLogo: "",
      urlResendEmailLogo: "",
      urlAlert: "",
    },
    InputUko: {
      colorInputLetter: "",
      borderInput: "",
      colorLabel: "",
      colorLabelFocus: "",
      colorIcon: "",
      backgroundColor: "",
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "#D1E2F0",
      buttonUkoColorDisabled: "#FFFFFF",
      buttonUkoBackgroundActive: "",
      buttonUkoBackgroundSuccess: "",
      buttonUkoColorDisabledResetPwd: "",
    },
    linkUko: {
      colorLink: "",
    },
    typographyMessageUko: {
      textColor: '',
    },
    versionUko: {
      colorVersionLabel: ""
    },
    alertUko: {
      imageUko: "",
      colorTextUko: "",
    },
    forgotPassword: {
      colorForgotPwd: "",
    },
    typographyText:{
      textColor: "",
      pathColor: ""
    },
    selectAccount: {
      colorRoot: "",
      colorChecked: "",
    },
    widthImageLogo: "",
    colorLoading:"",
    errorBox: {
      color: "",
      backgroundColor: "",
    },
    statusLicense: {
      containerMessage: {
        backgroundColor: "",
      },
    },
    alertPopup: {
      iconClose: {
        color: "",
      },
      titleAlert: {
        color: "",
      },
      buttonCancel: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      buttonAccept: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      secondaryMessageText: {
        color: "",
      },
      mensajeModalMain: {},
    },
    iconColorError: {
      bgColorCards: {},
      appBgColorCards: {
        boxShadow: "",
      },
      rootCard: {},
      title: {
        color: "",
      },
      subtitle: {
        color: "",
      },
      cardHeader: {
        color: "",
      },
      featureName: {},
      featureValue: {
        color: "",
      },
      buttonCard: {
        backgroundColor: "",
        color: "",
      },
      hoverButtonCard: {
        color: "",
        backgroundColor: "",
      },
      iconCard: {
        color: "",
      },
      btnDirectPlan: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      circularColor: {
        color: "",
      },
      tablePlanTable: {
        color: "",
        backgroundColor: "",
        fontWeight: "",
      },
      tableCellPlanTable: {
        color: "",
        backgroundColor: "",
      },
      purchasedPlans: {
        color: "",
        fontWeight: "",
      },
      plansTypography: {
        color: "",
        marginLeft: 0,
      },
      spanPlanTable: {
        color: "",
      },
      reportIcon: {
        color: "",
      },
    },
    passwordCheckColor:{
      borderInput: ""
    }
  },
  "GSE Suite": {
    tenantLanguage: "es",
    primary: {
      light: "#009BDD",
      main: "#1D71B8",
      dark: "#003582",
      iconSend: "#003582",
    },
    secondary: {
      dark: "#E45501",
      main: "#FF0004",
      light: "#FFE5E6",
    },
    info: {
      light: "#00000026",
      main: "#00000080",
      dark: "#00000099",
    },
    text: {
      primary: "#009BDD",
    },
    background: {
      paper: "#ffffff",   // fondo de las cards
      input: "",
      adornmentPrimary: "",
      selectColorDefault: "#E6FFEF",
      selectUsersCertificates: "",
      adornmentSecondary: "",
      certificateButtonColor: "",
      selectIcon: "#007C2F",
      disabledButtonColor: "",
      backButtonColor: "",
      codeInputBorderColor: "",
      hr:""
    },
    letter: {
      color: "",
      disabledColor: "",
      typographyColor: "",
      codeInputTypographyColor: ""
    },
    logoSettings: {
      widthResendEmail: "",
      heightResendEmail: "",
      marginLeftResendEmail: "",
      widthResetPwd: "",
      heightAlertResetPassword: "",
      heightResetPassword: "",
      marginLeftResetPassword: "",
      widthImage: "",
    },
    urlLogo: {
      url: "",
      urlSignIn: "",
      urlRememberPasswordlogo: "",
      urlCheckEmaillogo: "",
      urlCheckEmailMoreBlue: "",
      urlInvalidLinkMoreBlue: "",
      urlRemeberAndInvalid: "",
      urlExpireTime: "",
      urlChangePasswordlogo: "",
      urlActivatePasswordlogo: "",
      urlSuccessAlertlogo: "",
      urlSuccessAccountActivated:"",
      urlCheckEmailAgain: "",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
      urlPasswordResetLogo: "",
      urlResendEmailLogo: "",
      urlAlert: "",
    },
    InputUko: {
      colorInputLetter: "",
      borderInput: "",
      colorLabel: "",
      colorLabelFocus: "",
      colorIcon: "",
      backgroundColor: "",
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "#D1E2F0",
      buttonUkoColorDisabled: "#FFFFFF",
      buttonUkoBackgroundActive: "",
      buttonUkoBackgroundSuccess: "",
      buttonUkoColorDisabledResetPwd: "",
    },
    linkUko: {
      colorLink: "",
    },
    typographyMessageUko: {
      textColor: '',
    },
    versionUko: {
      colorVersionLabel: ""
    },
    alertUko: {
      imageUko: "",
      colorTextUko: "",
    },
    forgotPassword: {
      colorForgotPwd: "",
    },
    typographyText:{
      textColor: "",
      pathColor: ""
    },
    selectAccount: {
      colorRoot: "",
      colorChecked: "",
    },
    widthImageLogo: "",
    colorLoading:"",
    errorBox: {
      color: "",
      backgroundColor: "",
    },
    statusLicense: {
      containerMessage: {
        backgroundColor: "",
      },
    },
    alertPopup: {
      iconClose: {
        color: "",
      },
      titleAlert: {
        color: "",
      },
      buttonCancel: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      buttonAccept: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      secondaryMessageText: {
        color: "",
      },
      mensajeModalMain: {},
    },
    iconColorError: {
      bgColorCards: {},
      appBgColorCards: {
        boxShadow: "",
      },
      rootCard: {},
      title: {
        color: "",
      },
      subtitle: {
        color: "",
      },
      cardHeader: {
        color: "",
      },
      featureName: {},
      featureValue: {
        color: "",
      },
      buttonCard: {
        backgroundColor: "",
        color: "",
      },
      hoverButtonCard: {
        color: "",
        backgroundColor: "",
      },
      iconCard: {
        color: "",
      },
      btnDirectPlan: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      circularColor: {
        color: "",
      },
      tablePlanTable: {
        color: "",
        backgroundColor: "",
        fontWeight: "",
      },
      tableCellPlanTable: {
        color: "",
        backgroundColor: "",
      },
      purchasedPlans: {
        color: "",
        fontWeight: "",
      },
      plansTypography: {
        color: "",
        marginLeft: 0,
      },
      spanPlanTable: {
        color: "",
      },
      reportIcon: {
        color: "",
      },
    },
    passwordCheckColor:{
      borderInput: ""
    }
  },
  oidc: {
    tenantLanguage: "es",
    primary: {
      light: "#009BDD",
      main: "#1D71B8",
      dark: "#003582",
      iconSend: "#003582",
    },
    secondary: {
      dark: "#E45501",
      main: "#FF0004",
      light: "#FFE5E6",
    },
    info: {
      light: "#00000026",
      main: "#00000080",
      dark: "#00000099",
    },
    error: {
      light: "#FA5A00",
      main: "#D80000",
      dark: "#D80000",
      secondary: "",
      typographyColor: ""
    },
    background: {
      paper: "#ffffff",   // fondo de las cards
      input: "",
      adornmentPrimary: "",
      selectColorDefault: "#E6FFEF",
      selectUsersCertificates: "",
      adornmentSecondary: "",
      certificateButtonColor: "",
      selectIcon: "#007C2F",
      disabledButtonColor: "",
      backButtonColor: "",
      codeInputBorderColor: "",
      hr:""
    },
    letter: {
      color: "",
      disabledColor: "",
      typographyColor: "",
      codeInputTypographyColor: ""
    },
    logoSettings: {
      widthResendEmail: "",
      heightResendEmail: "",
      marginLeftResendEmail: "",
      widthResetPwd: "",
      heightAlertResetPassword: "",
      heightResetPassword: "",
      marginLeftResetPassword: "",
      widthImage: "",
    },
    urlLogo: {
      url: "",
      urlSignIn: "",
      urlRememberPasswordlogo: "",
      urlCheckEmaillogo: "",
      urlCheckEmailMoreBlue: "",
      urlInvalidLinkMoreBlue: "",
      urlRemeberAndInvalid: "",
      urlExpireTime: "",
      urlChangePasswordlogo: "",
      urlActivatePasswordlogo: "",
      urlSuccessAlertlogo: "",
      urlSuccessAccountActivated:"",
      urlCheckEmailAgain: "",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
      urlPasswordResetLogo: "",
      urlResendEmailLogo: "",
      urlAlert: "",
    },
    InputUko: {
      colorInputLetter: "",
      borderInput: "",
      colorLabel: "",
      colorLabelFocus: "",
      colorIcon: "",
      backgroundColor: "",
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "#D1E2F0",
      buttonUkoColorDisabled: "#FFFFFF",
      buttonUkoBackgroundActive: "",
      buttonUkoBackgroundSuccess: "",
      buttonUkoColorDisabledResetPwd: "",
    },
    linkUko: {
      colorLink: "",
    },
    typographyMessageUko: {
      textColor: '',
    },
    versionUko: {
      colorVersionLabel: ""
    },
    alertUko: {
      imageUko: "",
      colorTextUko: "",
    },
    forgotPassword: {
      colorForgotPwd: "",
    },
    typographyText:{
      textColor: "",
      pathColor: ""
    },
    selectAccount: {
      colorRoot: "",
      colorChecked: "",
    },
    widthImageLogo: "",
    colorLoading:"",
    errorBox: {
      color: "",
      backgroundColor: "",
    },
    statusLicense: {
      containerMessage: {
        backgroundColor: "",
      },
    },
    alertPopup: {
      iconClose: {
        color: "",
      },
      titleAlert: {
        color: "",
      },
      buttonCancel: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      buttonAccept: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      secondaryMessageText: {
        color: "",
      },
      mensajeModalMain: {},
    },
    iconColorError: {
      bgColorCards: {},
      appBgColorCards: {
        boxShadow: "",
      },
      rootCard: {},
      title: {
        color: "",
      },
      subtitle: {
        color: "",
      },
      cardHeader: {
        color: "",
      },
      featureName: {},
      featureValue: {
        color: "",
      },
      buttonCard: {
        backgroundColor: "",
        color: "",
      },
      hoverButtonCard: {
        color: "",
        backgroundColor: "",
      },
      iconCard: {
        color: "",
      },
      btnDirectPlan: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      circularColor: {
        color: "",
      },
      tablePlanTable: {
        color: "",
        backgroundColor: "",
        fontWeight: "",
      },
      tableCellPlanTable: {
        color: "",
        backgroundColor: "",
      },
      purchasedPlans: {
        color: "",
        fontWeight: "",
      },
      plansTypography: {
        color: "",
        marginLeft: 0,
      },
      spanPlanTable: {
        color: "",
      },
      reportIcon: {
        color: "",
      },
    },
    passwordCheckColor:{
      borderInput: ""
    }
  },
  biometria: {
    tenantLanguage: "es",
    primary: {
      light: "#009BDD",
      main: "#1D71B8",
      dark: "#003582",
      iconSend: "#003582",
    },
    secondary: {
      dark: "#E45501",
      main: "#FF0004",
      light: "#FFE5E6",
      titleText: "#E55200",
    },
    info: {
      light: "#D5D5D5",
      main: "#00000080",
      dark: "#C1C1C1",
    },
    error: {
      light: "#FA5A00",
      main: "#D80000",
      dark: "#D80000",
      secondary: "",
      typographyColor: ""
    },
    background: {
      paper: "#ffffff",   // fondo de las cards
      input: "",
      adornmentPrimary: "",
      selectColorDefault: "#E6FFEF",
      selectUsersCertificates: "",
      adornmentSecondary: "",
      certificateButtonColor: "",
      selectIcon: "#007C2F",
      disabledButtonColor: "",
      backButtonColor: "",
      codeInputBorderColor: "",
      hr:""
    },
    letter: {
      color: "",
      disabledColor: "",
      typographyColor: "",
      codeInputTypographyColor: ""
    },
    logoSettings: {
      widthResendEmail: "",
      heightResendEmail: "",
      marginLeftResendEmail: "",
      widthResetPwd: "",
      heightAlertResetPassword: "",
      heightResetPassword: "",
      marginLeftResetPassword: "",
      widthImage: "",
    },
    urlLogo: {
      url: "",
      urlSignIn: "",
      urlRememberPasswordlogo: "",
      urlCheckEmaillogo: "",
      urlCheckEmailMoreBlue: "",
      urlInvalidLinkMoreBlue: "",
      urlRemeberAndInvalid: "",
      urlExpireTime: "",
      urlChangePasswordlogo: "",
      urlActivatePasswordlogo: "",
      urlSuccessAlertlogo: "",
      urlSuccessAccountActivated:"",
      urlCheckEmailAgain: "",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
      urlPasswordResetLogo: "",
      urlResendEmailLogo: "",
      urlAlert: "",
    },
    InputUko: {
      colorInputLetter: "",
      borderInput: "",
      colorLabel: "",
      colorLabelFocus: "",
      colorIcon: "",
      backgroundColor: "",
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "#D1E2F0",
      buttonUkoColorDisabled: "#FFFFFF",
      buttonUkoBackgroundActive: "",
      buttonUkoBackgroundSuccess: "",
      buttonUkoColorDisabledResetPwd: "",
    },
    linkUko: {
      colorLink: "",
    },
    typographyMessageUko: {
      textColor: '',
    },
    versionUko: {
      colorVersionLabel: ""
    },
    alertUko: {
      imageUko: "",
      colorTextUko: "",
    },
    forgotPassword: {
      colorForgotPwd: "",
    },
    typographyText:{
      textColor: "",
      pathColor: ""
    },
    selectAccount: {
      colorRoot: "",
      colorChecked: "",
    },
    widthImageLogo: "",
    colorLoading:"",
    errorBox: {
      color: "",
      backgroundColor: "",
    },
    statusLicense: {
      containerMessage: {
        backgroundColor: "",
      },
    },
    alertPopup: {
      iconClose: {
        color: "",
      },
      titleAlert: {
        color: "",
      },
      buttonCancel: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      buttonAccept: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      secondaryMessageText: {
        color: "",
      },
      mensajeModalMain: {},
    },
    iconColorError: {
      bgColorCards: {},
      appBgColorCards: {
        boxShadow: "",
      },
      rootCard: {},
      title: {
        color: "",
      },
      subtitle: {
        color: "",
      },
      cardHeader: {
        color: "",
      },
      featureName: {},
      featureValue: {
        color: "",
      },
      buttonCard: {
        backgroundColor: "",
        color: "",
      },
      hoverButtonCard: {
        color: "",
        backgroundColor: "",
      },
      iconCard: {
        color: "",
      },
      btnDirectPlan: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      circularColor: {
        color: "",
      },
      tablePlanTable: {
        color: "",
        backgroundColor: "",
        fontWeight: "",
      },
      tableCellPlanTable: {
        color: "",
        backgroundColor: "",
      },
      purchasedPlans: {
        color: "",
        fontWeight: "",
      },
      plansTypography: {
        color: "",
        marginLeft: 0,
      },
      spanPlanTable: {
        color: "",
      },
      reportIcon: {
        color: "",
      },
    },
    passwordCheckColor:{
      borderInput: ""
    }
  },
  biometria_gse: {
    tenantLanguage: "es",
    primary: {
      light: "#009BDD",
      main: "#1D71B8",
      dark: "#003582",
      iconSend: "#003582",
    },
    secondary: {
      dark: "#E45501",
      main: "#FF0004",
      light: "#FFE5E6",
      titleText: "#E55200",
    },
    info: {
      light: "#D5D5D5",
      main: "#00000080",
      dark: "#C1C1C1",
    },
    error: {
      light: "#FA5A00",
      main: "#D80000",
      dark: "#D80000",
      secondary: "",
      typographyColor: ""
    },
    background: {
      paper: "#ffffff",   // fondo de las cards
      input: "",
      adornmentPrimary: "",
      selectColorDefault: "#E6FFEF",
      selectUsersCertificates: "",
      adornmentSecondary: "",
      certificateButtonColor: "",
      selectIcon: "#007C2F",
      disabledButtonColor: "",
      backButtonColor: "",
      codeInputBorderColor: "",
      hr:""
    },
    letter: {
      color: "",
      disabledColor: "",
      typographyColor: "",
      codeInputTypographyColor: ""
    },
    logoSettings: {
      widthResendEmail: "",
      heightResendEmail: "",
      marginLeftResendEmail: "",
      widthResetPwd: "",
      heightAlertResetPassword: "",
      heightResetPassword: "",
      marginLeftResetPassword: "",
      widthImage: "",
    },
    urlLogo: {
      url: "",
      urlSignIn: "",
      urlRememberPasswordlogo: "",
      urlCheckEmaillogo: "",
      urlCheckEmailMoreBlue: "",
      urlInvalidLinkMoreBlue: "",
      urlRemeberAndInvalid: "",
      urlExpireTime: "",
      urlChangePasswordlogo: "",
      urlActivatePasswordlogo: "",
      urlSuccessAlertlogo: "",
      urlSuccessAccountActivated:"",
      urlCheckEmailAgain: "",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
      urlPasswordResetLogo: "",
      urlResendEmailLogo: "",
      urlAlert: "",
    },
    InputUko: {
      colorInputLetter: "",
      borderInput: "",
      colorLabel: "",
      colorLabelFocus: "",
      colorIcon: "",
      backgroundColor: "",
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "#D1E2F0",
      buttonUkoColorDisabled: "#FFFFFF",
      buttonUkoBackgroundActive: "",
      buttonUkoBackgroundSuccess: "",
      buttonUkoColorDisabledResetPwd: "",
    },
    linkUko: {
      colorLink: "",
    },
    typographyMessageUko: {
      textColor: '',
    },
    versionUko: {
      colorVersionLabel: ""
    },
    alertUko: {
      imageUko: "",
      colorTextUko: "",
    },
    forgotPassword: {
      colorForgotPwd: "",
    },
    typographyText:{
      textColor: "",
      pathColor: ""
    },
    selectAccount: {
      colorRoot: "",
      colorChecked: "",
    },
    widthImageLogo: "",
    colorLoading:"",
    errorBox: {
      color: "",
      backgroundColor: "",
    },
    statusLicense: {
      containerMessage: {
        backgroundColor: "",
      },
    },
    alertPopup: {
      iconClose: {
        color: "",
      },
      titleAlert: {
        color: "",
      },
      buttonCancel: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      buttonAccept: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      secondaryMessageText: {
        color: "",
      },
      mensajeModalMain: {},
    },
    iconColorError: {
      bgColorCards: {},
      appBgColorCards: {
        boxShadow: "",
      },
      rootCard: {},
      title: {
        color: "",
      },
      subtitle: {
        color: "",
      },
      cardHeader: {
        color: "",
      },
      featureName: {},
      featureValue: {
        color: "",
      },
      buttonCard: {
        backgroundColor: "",
        color: "",
      },
      hoverButtonCard: {
        color: "",
        backgroundColor: "",
      },
      iconCard: {
        color: "",
      },
      btnDirectPlan: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      circularColor: {
        color: "",
      },
      tablePlanTable: {
        color: "",
        backgroundColor: "",
        fontWeight: "",
      },
      tableCellPlanTable: {
        color: "",
        backgroundColor: "",
      },
      purchasedPlans: {
        color: "",
        fontWeight: "",
      },
      plansTypography: {
        color: "",
        marginLeft: 0,
      },
      spanPlanTable: {
        color: "",
      },
      reportIcon: {
        color: "",
      },
    },
    passwordCheckColor:{
      borderInput: ""
    }
  },
  biometria_fna: {
    tenantLanguage: "es",
    primary: {
      light: "#009BDD",
      main: "#1D71B8",
      dark: "#003582",
      iconSend: "#003582",
    },
    secondary: {
      dark: "#E45501",
      main: "#FF0004",
      light: "#FFE5E6",
      titleText: "#E55200",
    },
    info: {
      light: "#D5D5D5",
      main: "#00000080",
      dark: "#C1C1C1",
    },
    error: {
      light: "#FA5A00",
      main: "#D80000",
      dark: "#D80000",
      secondary: "",
      typographyColor: ""
    },
    background: {
      paper: "#ffffff",   // fondo de las cards
      input: "",
      adornmentPrimary: "",
      selectColorDefault: "#E6FFEF",
      selectUsersCertificates: "",
      adornmentSecondary: "",
      certificateButtonColor: "",
      selectIcon: "#007C2F",
      disabledButtonColor: "",
      backButtonColor: "",
      codeInputBorderColor: "",
      hr:""
    },
    letter: {
      color: "",
      disabledColor: "",
      typographyColor: "",
      codeInputTypographyColor: ""
    },
    logoSettings: {
      widthResendEmail: "",
      heightResendEmail: "",
      marginLeftResendEmail: "",
      widthResetPwd: "",
      heightAlertResetPassword: "",
      heightResetPassword: "",
      marginLeftResetPassword: "",
      widthImage: "",
    },
    urlLogo: {
      url: "",
      urlSignIn: "",
      urlRememberPasswordlogo: "",
      urlCheckEmaillogo: "",
      urlCheckEmailMoreBlue: "",
      urlInvalidLinkMoreBlue: "",
      urlRemeberAndInvalid: "",
      urlExpireTime: "",
      urlChangePasswordlogo: "",
      urlActivatePasswordlogo: "",
      urlSuccessAlertlogo: "",
      urlSuccessAccountActivated:"",
      urlCheckEmailAgain: "",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
      urlPasswordResetLogo: "",
      urlResendEmailLogo: "",
      urlAlert: "",
    },
    InputUko: {
      colorInputLetter: "",
      borderInput: "",
      colorLabel: "",
      colorLabelFocus: "",
      colorIcon: "",
      backgroundColor: "",
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "",
      buttonUkoColorDisabled: "",
      buttonUkoBackgroundActive: "",
      buttonUkoBackgroundSuccess: "",
      buttonUkoColorDisabledResetPwd: "",
    },
    linkUko: {
      colorLink: "",
    },
    typographyMessageUko: {
      textColor: '',
    },
    versionUko: {
      colorVersionLabel: ""
    },
    alertUko: {
      imageUko: "",
      colorTextUko: "",
    },
    forgotPassword: {
      colorForgotPwd: "",
    },
    typographyText:{
      textColor: "",
      pathColor: ""
    },
    selectAccount: {
      colorRoot: "",
      colorChecked: "",
    },
    widthImageLogo: "",
    colorLoading:"",
    errorBox: {
      color: "",
      backgroundColor: "",
    },
    statusLicense: {
      containerMessage: {
        backgroundColor: "",
      },
    },
    alertPopup: {
      iconClose: {
        color: "",
      },
      titleAlert: {
        color: "",
      },
      buttonCancel: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      buttonAccept: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      secondaryMessageText: {
        color: "",
      },
      mensajeModalMain: {},
    },
    iconColorError: {
      bgColorCards: {},
      appBgColorCards: {
        boxShadow: "",
      },
      rootCard: {},
      title: {
        color: "",
      },
      subtitle: {
        color: "",
      },
      cardHeader: {
        color: "",
      },
      featureName: {},
      featureValue: {
        color: "",
      },
      buttonCard: {
        backgroundColor: "",
        color: "",
      },
      hoverButtonCard: {
        color: "",
        backgroundColor: "",
      },
      iconCard: {
        color: "",
      },
      btnDirectPlan: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      circularColor: {
        color: "",
      },
      tablePlanTable: {
        color: "",
        backgroundColor: "",
        fontWeight: "",
      },
      tableCellPlanTable: {
        color: "",
        backgroundColor: "",
      },
      purchasedPlans: {
        color: "",
        fontWeight: "",
      },
      plansTypography: {
        color: "",
        marginLeft: 0,
      },
      spanPlanTable: {
        color: "",
      },
      reportIcon: {
        color: "",
      },
    },
    passwordCheckColor:{
      borderInput: ""
    }
  },
  confronta: {
    tenantLanguage: "es",
    primary: {
      light: "#009BDD",
      main: "#1D71B8",
      dark: "#003582",
      iconSend: "#003582",
    },
    secondary: {
      dark: "#E45501",
      main: "#FF0004",
      light: "#FFE5E6",
      titleText: "#E55200",
    },
    info: {
      light: "#D5D5D5",
      main: "#00000080",
      dark: "#C1C1C1",
    },
    error: {
      light: "#FA5A00",
      main: "#D80000",
      dark: "#D80000",
      secondary: "",
      typographyColor: ""
    },
    background: {
      paper: "#ffffff",   // fondo de las cards
      input: "",
      adornmentPrimary: "",
      selectColorDefault: "#E6FFEF",
      selectUsersCertificates: "",
      adornmentSecondary: "",
      certificateButtonColor: "",
      selectIcon: "#007C2F",
      disabledButtonColor: "",
      backButtonColor: "",
      codeInputBorderColor: "",
      hr:""
    },
    letter: {
      color: "",
      disabledColor: "",
      typographyColor: "",
      codeInputTypographyColor: ""
    },
    logoSettings: {
      widthResendEmail: "",
      heightResendEmail: "",
      marginLeftResendEmail: "",
      widthResetPwd: "",
      heightAlertResetPassword: "",
      heightResetPassword: "",
      marginLeftResetPassword: "",
      widthImage: "",
    },
    urlLogo: {
      url: "",
      urlSignIn: "",
      urlRememberPasswordlogo: "",
      urlCheckEmaillogo: "",
      urlCheckEmailMoreBlue: "",
      urlInvalidLinkMoreBlue: "",
      urlRemeberAndInvalid: "",
      urlExpireTime: "",
      urlChangePasswordlogo: "",
      urlActivatePasswordlogo: "",
      urlSuccessAlertlogo: "",
      urlSuccessAccountActivated:"",
      urlCheckEmailAgain: "",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
      urlPasswordResetLogo: "",
      urlResendEmailLogo: "",
      urlAlert: "",
    },
    InputUko: {
      colorInputLetter: "",
      borderInput: "",
      colorLabel: "",
      colorLabelFocus: "",
      colorIcon: "",
      backgroundColor: "",
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "#D1E2F0",
      buttonUkoColorDisabled: "#FFFFFF",
      buttonUkoBackgroundActive: "",
      buttonUkoBackgroundSuccess: "",
      buttonUkoColorDisabledResetPwd: "",
    },
    linkUko: {
      colorLink: "",
    },
    typographyMessageUko: {
      textColor: '',
    },
    versionUko: {
      colorVersionLabel: ""
    },
    alertUko: {
      imageUko: "",
      colorTextUko: "",
    },
    forgotPassword: {
      colorForgotPwd: "",
    },
    typographyText:{
      textColor: "",
      pathColor: ""
    },
    selectAccount: {
      colorRoot: "",
      colorChecked: "",
    },
    widthImageLogo: "",
    colorLoading:"",
    errorBox: {
      color: "",
      backgroundColor: "",
    },
    statusLicense: {
      containerMessage: {
        backgroundColor: "",
      },
    },
    alertPopup: {
      iconClose: {
        color: "",
      },
      titleAlert: {
        color: "",
      },
      buttonCancel: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      buttonAccept: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      secondaryMessageText: {
        color: "",
      },
      mensajeModalMain: {},
    },
    iconColorError: {
      bgColorCards: {},
      appBgColorCards: {
        boxShadow: "",
      },
      rootCard: {},
      title: {
        color: "",
      },
      subtitle: {
        color: "",
      },
      cardHeader: {
        color: "",
      },
      featureName: {},
      featureValue: {
        color: "",
      },
      buttonCard: {
        backgroundColor: "",
        color: "",
      },
      hoverButtonCard: {
        color: "",
        backgroundColor: "",
      },
      iconCard: {
        color: "",
      },
      btnDirectPlan: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      circularColor: {
        color: "",
      },
      tablePlanTable: {
        color: "",
        backgroundColor: "",
        fontWeight: "",
      },
      tableCellPlanTable: {
        color: "",
        backgroundColor: "",
      },
      purchasedPlans: {
        color: "",
        fontWeight: "",
      },
      plansTypography: {
        color: "",
        marginLeft: 0,
      },
      spanPlanTable: {
        color: "",
      },
      reportIcon: {
        color: "",
      },
    },
    passwordCheckColor:{
      borderInput: ""
    }
  },
  myselfcert: {
    tenantLanguage: "es",
    primary: {
      light: "#8AB9F2",
      main: "#2499EF",
      dark: "#003582",
      iconSend: "#003582",
    },
    secondary: {
      dark: "#E45501",
      main: "rgba(52, 73, 94, 1)",
      light: "#F5F8FA",
      titleText: "#121F43"
    },
    info: {
      light: "#335474",
      main: "#00000080",
      dark: "#C1C1C1",
    },
    error: {
      light: "#FF316F",
      main: "#FF316F1A",
      dark: "#FF316F",
      secondary: "",
      typographyColor: "#FF316F"
    },
    background: {
      paper: "#ffffff",   // fondo de las cards
      input: "",
      adornmentPrimary: "",
      selectColorDefault: "#27CE881A",
      selectUsersCertificates: "",
      adornmentSecondary: "",
      certificateButtonColor: "",
      selectIcon: "#1D9C67",
      disabledButtonColor: "",
      backButtonColor: "",
      codeInputBorderColor: "",
      hr:""
    },
    letter: {
      color: "",
      disabledColor: "",
      typographyColor: "",
      codeInputTypographyColor: ""
    },
    logoSettings: {
      widthResendEmail: "",
      heightResendEmail: "",
      marginLeftResendEmail: "",
      widthResetPwd: "",
      heightAlertResetPassword: "",
      heightResetPassword: "",
      marginLeftResetPassword: "",
      widthImage: "",
    },
    urlLogo: {
      url: "LogosUko/myselfcert/LoginUko.png",
      urlSignIn: "LogosUko/myselfcert/LogoSignInUko.png",
      urlRememberPasswordlogo: "LogosUko/myselfcert/RememberPasswordUko.png",
      urlCheckEmaillogo: "LogosUko/myselfcert/CheckEmail.svg",
      urlCheckEmailMoreBlue: "LogosUko/letmicert/Mail_Icon.svg",
      urlInvalidLinkMoreBlue: "LogosUko/letmicert/Break_icon.svg",
      urlRemeberAndInvalid: "LogosUko/myselfcert/RememberPasswordInvalidUrl.png",
      urlExpireTime: "LogosUko/letmicert/Alert_Icon.svg",
      urlChangePasswordlogo: "LogosUko/myselfcert/ChangePassword.png",
      urlActivatePasswordlogo: "LogosUko/myselfcert/activateAccount.svg",
      urlSuccessAlertlogo: "LogosUko/myselfcert/PasswordUpdated.png",
      urlSuccessAccountActivated:"LogosUko/myselfcert/PasswordUpdated.png",
      urlCheckEmailAgain: "LogosUko/letmicert/Mail_Icon.svg",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
      urlPasswordResetLogo: "",
      urlResendEmailLogo: "LogosUko/myselfcert/LogoSignInUko.png",
      urlAlert: "LogosUko/myselfcert/LogoSignInUko.png",
    },
    InputUko: {
      colorInputLetter: "#011E3D",
      borderInput: "#738499",
      colorLabel: "#738499",
      colorLabelFocus: "#2499EF",
      colorIcon: "#738499",
      backgroundColor: "#FFFFFF"
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "#DCE5F0",
      buttonUkoColorDisabled: "#A7BEDA",
      buttonUkoBackgroundActive: "#34495E",
      buttonUkoBackgroundSuccess: "#FFFFFF",
      buttonUkoColorDisabledResetPwd: "",
    },
    linkUko: {
      colorLink: "#2499EF",
    },
    typographyMessageUko: {
      textColor: '#335474',
    },
    versionUko: {
      colorVersionLabel: "#335474"
    },
    alertUko: {
      imageUko: "LogosUko//letmicert/InfoIcon.svg",
      colorTextUko: "#335474",
    },
    forgotPassword: {
      colorForgotPwd: "",
    },
    typographyText:{
      textColor: '#738499',
      pathColor: '#FFFFFF'
    },
    selectAccount: {
      colorRoot: "",
      colorChecked: "",
    },
    widthImageLogo: "115.71px",
    colorLoading:"",
    errorBox: {
      color: "",
      backgroundColor: "",
    },
    statusLicense: {
      containerMessage: {
        backgroundColor: "",
      },
    },
    alertPopup: {
      iconClose: {
        color: "",
      },
      titleAlert: {
        color: "",
      },
      buttonCancel: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      buttonAccept: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      secondaryMessageText: {
        color: "",
      },
      mensajeModalMain: {},
    },
    iconColorError: {
      bgColorCards: {},
      appBgColorCards: {
        boxShadow: "",
      },
      rootCard: {},
      title: {
        color: "",
      },
      subtitle: {
        color: "",
      },
      cardHeader: {
        color: "",
      },
      featureName: {},
      featureValue: {
        color: "",
      },
      buttonCard: {
        backgroundColor: "",
        color: "",
      },
      hoverButtonCard: {
        color: "",
        backgroundColor: "",
      },
      iconCard: {
        color: "",
      },
      btnDirectPlan: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      circularColor: {
        color: "",
      },
      tablePlanTable: {
        color: "",
        backgroundColor: "",
        fontWeight: "",
      },
      tableCellPlanTable: {
        color: "",
        backgroundColor: "",
      },
      purchasedPlans: {
        color: "",
        fontWeight: "",
      },
      plansTypography: {
        color: "",
        marginLeft: 0,
      },
      spanPlanTable: {
        color: "",
      },
      reportIcon: {
        color: "",
      },
    },
    passwordCheckColor:{
      borderInput: "#738499"
    }
  },
  letmicert: {
    tenantLanguage: "es",
    primary: {
      light: "#1E1A34",
      main: "#0059AD",
      dark: "#003582",
      iconSend: "#003582",
    },
    secondary: {
      dark: "#E45501",
      main: "rgba(52, 73, 94, 1)",
      light: "#ffffff",
      titleText: "#121F43"
    },
    info: {
      light: "#335474",
      main: "#00000080",
      dark: "#C1C1C1",
    },
    error: {
      light: "#F71554",
      main: "#FF316F1A",
      dark: "#F71554",
      secondary: "",
      typographyColor: "#E1134C"
    },
    background: {
      paper: "#ffffff",   // fondo de las cards
      input: "",
      adornmentPrimary: "",
      selectColorDefault: "#E6FBF8",
      selectUsersCertificates: "",
      adornmentSecondary: "",
      certificateButtonColor: "",
      selectIcon: "#047763",
      disabledButtonColor: "",
      backButtonColor: "",
      codeInputBorderColor: "",
      hr:""
    },
    letter: {
      color: "#163357",
      disabledColor: "",
      typographyColor: "",
      codeInputTypographyColor: ""
    },
    logoSettings: {
      widthResendEmail: "",
      heightResendEmail: "80px",
      marginLeftResendEmail: "",
      widthResetPwd: "185.10px",
      heightAlertResetPassword: "64px",
      heightResetPassword: "",
      marginLeftResetPassword: "",
      widthImage: "80px",
    },
    urlLogo: {
      url: "LogosUko//letmicert/Letmi_login.png",
      urlSignIn: "LogosUko//letmicert/Letmicert_logo.svg",
      urlRememberPasswordlogo: "LogosUko//letmicert/RememberPasswordUko.png",
      urlCheckEmaillogo: "LogosUko//letmicert/SendEmail.png",
      urlCheckEmailMoreBlue: "LogosUko//letmicert/Mail_Icon.svg",
      urlInvalidLinkMoreBlue: "LogosUko//letmicert/InvalidLinkMoreBlue.png",
      urlRemeberAndInvalid: "LogosUko//myselfcert/RememberPasswordInvalidUrl.png",
      urlExpireTime: "LogosUko//letmicert/ExpireTime.png",
      urlChangePasswordlogo: "LogosUko//letmicert/ChangePassword.png",
      urlActivatePasswordlogo: "LogosUko//letmicert/ActivatePassword.png",
      urlSuccessAlertlogo: "LogosUko//letmicert/PasswordUpdated.png",
      urlSuccessAccountActivated:"LogosUko//letmicert/PasswordUpdated.png",
      urlCheckEmailAgain: "LogosUko//letmicert/CheckEmailAgain.png",
      urlMaintenanceImage: "myselfcert/maintenanceImage.png",
      urlWhiteGseLogo: "myselfcert/whiteGseLogo.png",
      urlPasswordResetLogo: "",
      urlResendEmailLogo: "letmicertLogo.svg",
      urlAlert: "letmicertLogo.svg",
    },
    InputUko: {
      colorInputLetter: "#011E3D",
      borderInput: "#455C79",
      colorLabel: "#455C79",
      colorLabelFocus: "#163357",
      colorIcon: "#455C79",
      backgroundColor: "#FFFFFF"
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "#F2F6FA",
      buttonUkoColorDisabled: "#B0CCE6",
      buttonUkoBackgroundActive: "#0059AD",
      buttonUkoBackgroundSuccess: "#FFFFFF",
      buttonUkoColorDisabledResetPwd: "",
    },
    linkUko: {
      colorLink: "#163357",
    },
    typographyMessageUko: {
      textColor: '#163357',
    },
    versionUko: {
      colorVersionLabel: "#335474"
    },
    alertUko: {
      imageUko: "LogosUko//letmicert/InfoIcon.svg",
      colorTextUko: "#163357",
    },
    forgotPassword: {
      colorForgotPwd: "",
    },
    typographyText:{
      textColor: '#163357',
      pathColor: '#FFFFFF'
    },
    selectAccount: {
      colorRoot: "",
      colorChecked: "",
    },
    widthImageLogo: "200px",
    colorLoading:"#2499EF",
    errorBox: {
      color: "",
      backgroundColor: "",
    },
    statusLicense: {
      containerMessage: {
        backgroundColor: "",
      },
    },
    alertPopup: {
      iconClose: {
        color: "#455C79",
      },
      titleAlert: {
        color: "",
      },
      buttonCancel: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      buttonAccept: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      secondaryMessageText: {
        color: "",
      },
      mensajeModalMain: {},
    },
    iconColorError: {
      bgColorCards: {},
      appBgColorCards: {
        boxShadow: "",
      },
      rootCard: {},
      title: {
        color: "",
      },
      subtitle: {
        color: "",
      },
      cardHeader: {
        color: "",
      },
      featureName: {},
      featureValue: {
        color: "",
      },
      buttonCard: {
        backgroundColor: "",
        color: "",
      },
      hoverButtonCard: {
        color: "",
        backgroundColor: "",
      },
      iconCard: {
        color: "",
      },
      btnDirectPlan: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      circularColor: {
        color: "",
      },
      tablePlanTable: {
        color: "",
        backgroundColor: "",
        fontWeight: "",
      },
      tableCellPlanTable: {
        color: "",
        backgroundColor: "",
      },
      purchasedPlans: {
        color: "",
        fontWeight: "",
      },
      plansTypography: {
        color: "",
        marginLeft: 0,
      },
      spanPlanTable: {
        color: "",
      },
      reportIcon: {
        color: "",
      },
    },
    passwordCheckColor:{
      borderInput: "#0059AD"
    },
  },
  pancert: {
    tenantLanguage: "es",
    primary: {
      light: "#1E1A34",
      main: "#0059AD",
      dark: "#003582",
      iconSend: "#003582",
    },
    secondary: {
      dark: "#E45501",
      main: "rgba(52, 73, 94, 1)",
      light: "#ffffff",
      titleText: "#121F43"
    },
    info: {
      light: "#335474",
      main: "#00000080",
      dark: "#C1C1C1",
    },
    error: {
      light: "#FF316F",
      main: "#FF316F1A",
      dark: "#FF316F",
      secondary: "",
      typographyColor: "#FF316F"
    },
    background: {
      paper: "#ffffff",   // fondo de las cards
      input: "",
      adornmentPrimary: "",
      selectColorDefault: "#E6FBF8",
      selectUsersCertificates: "",
      adornmentSecondary: "",
      certificateButtonColor: "",
      selectIcon: "#047763",
      disabledButtonColor: "",
      backButtonColor: "",
      codeInputBorderColor: "",
      hr:""
    },
    letter: {
      color: "#163357",
      disabledColor: "",
      typographyColor: "",
      codeInputTypographyColor: ""
    },
    logoSettings: {
      widthResendEmail: "",
      heightResendEmail: "80px",
      marginLeftResendEmail: "",
      widthResetPwd: "",
      heightAlertResetPassword: "",
      heightResetPassword: "",
      marginLeftResetPassword: "",
      widthImage: "80px",
    },
    urlLogo: {
      url: "LogosUko//letmicert/Letmi_login.png",
      urlSignIn: "LogosUko//letmicert/Letmicert_logo.svg",
      urlRememberPasswordlogo: "LogosUko//letmicert/RememberPasswordUko.png",
      urlCheckEmaillogo: "LogosUko//letmicert/SendEmail.png",
      urlCheckEmailMoreBlue: "LogosUko//letmicert/Mail_Icon.svg",
      urlInvalidLinkMoreBlue: "LogosUko//letmicert/InvalidLinkMoreBlue.png",
      urlRemeberAndInvalid: "LogosUko//myselfcert/RememberPasswordInvalidUrl.png",
      urlExpireTime: "LogosUko//letmicert/ExpireTime.png",
      urlChangePasswordlogo: "LogosUko//letmicert/ChangePassword.png",
      urlActivatePasswordlogo: "LogosUko//letmicert/ActivatePassword.png",
      urlSuccessAlertlogo: "LogosUko//letmicert/PasswordUpdated.png",
      urlSuccessAccountActivated:"LogosUko//letmicert/PasswordUpdated.png",
      urlCheckEmailAgain: "LogosUko//letmicert/CheckEmailAgain.png",
      urlMaintenanceImage: "myselfcert/maintenanceImage.png",
      urlWhiteGseLogo: "myselfcert/whiteGseLogo.png",
      urlPasswordResetLogo: "",
      urlResendEmailLogo: "letmicertLogo.svg",
      urlAlert: "letmicertLogo.svg",
    },
    InputUko: {
      colorInputLetter: "#011E3D",
      borderInput: "#455C79",
      colorLabel: "#738499",
      colorLabelFocus: "#163357",
      colorIcon: "#455C79",
      backgroundColor: "#FFFFFF"
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "#F2F6FA",
      buttonUkoColorDisabled: "#B0CCE6",
      buttonUkoBackgroundActive: "#0059AD",
      buttonUkoBackgroundSuccess: "#FFFFFF",
      buttonUkoColorDisabledResetPwd: "",
    },
    linkUko: {
      colorLink: "#163357",
    },
    typographyMessageUko: {
      textColor: '#163357',
    },
    versionUko: {
      colorVersionLabel: "#335474"
    },
    alertUko: {
      imageUko: "LogosUko//letmicert/InfoIcon.svg",
      colorTextUko: "#163357",
    },
    forgotPassword: {
      colorForgotPwd: "",
    },
    typographyText:{
      textColor: '#163357',
      pathColor: '#FFFFFF'
    },
    selectAccount: {
      colorRoot: "",
      colorChecked: "",
    },
    widthImageLogo: "200px",
    colorLoading:"#2499EF",
    errorBox: {
      color: "",
      backgroundColor: "",
    },
    statusLicense: {
      containerMessage: {
        backgroundColor: "",
      },
    },
    alertPopup: {
      iconClose: {
        color: "",
      },
      titleAlert: {
        color: "",
      },
      buttonCancel: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      buttonAccept: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      secondaryMessageText: {
        color: "",
      },
      mensajeModalMain: {},
    },
    iconColorError: {
      bgColorCards: {},
      appBgColorCards: {
        boxShadow: "",
      },
      rootCard: {},
      title: {
        color: "",
      },
      subtitle: {
        color: "",
      },
      cardHeader: {
        color: "",
      },
      featureName: {},
      featureValue: {
        color: "",
      },
      buttonCard: {
        backgroundColor: "",
        color: "",
      },
      hoverButtonCard: {
        color: "",
        backgroundColor: "",
      },
      iconCard: {
        color: "",
      },
      btnDirectPlan: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      circularColor: {
        color: "",
      },
      tablePlanTable: {
        color: "",
        backgroundColor: "",
        fontWeight: "",
      },
      tableCellPlanTable: {
        color: "",
        backgroundColor: "",
      },
      purchasedPlans: {
        color: "",
        fontWeight: "",
      },
      plansTypography: {
        color: "",
        marginLeft: 0,
      },
      spanPlanTable: {
        color: "",
      },
      reportIcon: {
        color: "",
      },
    },
    passwordCheckColor:{
      borderInput: "#455C79"
    }
  },
  license_letmicert: {
    tenantLanguage: "es",
    primary: {
      light: "#1E1A34",
      main: "#0059AD",
      dark: "#003582",
      iconSend: "#003582",
    },
    secondary: {
      dark: "#E45501",
      main: "rgba(52, 73, 94, 1)",
      light: "#ffffff",
      titleText: "#121F43"
    },
    info: {
      light: "#335474",
      main: "#00000080",
      dark: "#C1C1C1",
    },
    error: {
      light: "#FF316F",
      main: "#FF316F1A",
      dark: "#FF316F",
      secondary: "",
      typographyColor: "#FF316F"
    },
    background: {
      paper: "#ffffff",   // fondo de las cards
      input: "",
      adornmentPrimary: "",
      selectColorDefault: "#E6FBF8",
      selectUsersCertificates: "",
      adornmentSecondary: "",
      certificateButtonColor: "",
      selectIcon: "#047763",
      disabledButtonColor: "",
      backButtonColor: "",
      codeInputBorderColor: "",
      hr:""
    },
    letter: {
      color: "#163357",
      disabledColor: "",
      typographyColor: "",
      codeInputTypographyColor: ""
    },
    logoSettings: {
      widthResendEmail: "",
      heightResendEmail: "80px",
      marginLeftResendEmail: "",
      widthResetPwd: "",
      heightAlertResetPassword: "",
      heightResetPassword: "",
      marginLeftResetPassword: "",
      widthImage: "80px",
    },
    urlLogo: {
      url: "LogosUko//letmicert/Letmi_login.png",
      urlSignIn: "LogosUko//letmicert/Letmicert_logo.svg",
      urlRememberPasswordlogo: "LogosUko//letmicert/RememberPasswordUko.png",
      urlCheckEmaillogo: "LogosUko//letmicert/SendEmail.png",
      urlCheckEmailMoreBlue: "LogosUko//letmicert/Mail_Icon.svg",
      urlInvalidLinkMoreBlue: "LogosUko//letmicert/InvalidLinkMoreBlue.png",
      urlRemeberAndInvalid: "LogosUko//myselfcert/RememberPasswordInvalidUrl.png",
      urlExpireTime: "LogosUko//letmicert/ExpireTime.png",
      urlChangePasswordlogo: "LogosUko//letmicert/ChangePassword.png",
      urlActivatePasswordlogo: "LogosUko//letmicert/ActivatePassword.png",
      urlSuccessAlertlogo: "LogosUko//letmicert/PasswordUpdated.png",
      urlSuccessAccountActivated:"LogosUko//letmicert/PasswordUpdated.png",
      urlCheckEmailAgain: "LogosUko//letmicert/CheckEmailAgain.png",
      urlMaintenanceImage: "myselfcert/maintenanceImage.png",
      urlWhiteGseLogo: "myselfcert/whiteGseLogo.png",
      urlPasswordResetLogo: "",
      urlResendEmailLogo: "letmicertLogo.svg",
      urlAlert: "letmicertLogo.svg",
    },
    InputUko: {
      colorInputLetter: "#011E3D",
      borderInput: "#455C79",
      colorLabel: "#738499",
      colorLabelFocus: "#163357",
      colorIcon: "#455C79",
      backgroundColor: "#FFFFFF"
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "#F2F6FA",
      buttonUkoColorDisabled: "#B0CCE6",
      buttonUkoBackgroundActive: "#0059AD",
      buttonUkoBackgroundSuccess: "#FFFFFF",
      buttonUkoColorDisabledResetPwd: "",
    },
    linkUko: {
      colorLink: "#163357",
    },
    typographyMessageUko: {
      textColor: '#163357',
    },
    versionUko: {
      colorVersionLabel: "#335474"
    },
    alertUko: {
      imageUko: "LogosUko//letmicert/InfoIcon.svg",
      colorTextUko: "#163357",
    },
    forgotPassword: {
      colorForgotPwd: "",
    },
    typographyText:{
      textColor: '#163357',
      pathColor: '#FFFFFF'
    },
    selectAccount: {
      colorRoot: "",
      colorChecked: "",
    },
    widthImageLogo: "200px",
    colorLoading:"#2499EF",
    errorBox: {
      color: "",
      backgroundColor: "",
    },
    statusLicense: {
      containerMessage: {
        backgroundColor: "",
      },
    },
    alertPopup: {
      iconClose: {
        color: "",
      },
      titleAlert: {
        color: "",
      },
      buttonCancel: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      buttonAccept: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      secondaryMessageText: {
        color: "",
      },
      mensajeModalMain: {},
    },
    iconColorError: {
      bgColorCards: {},
      appBgColorCards: {
        boxShadow: "",
      },
      rootCard: {},
      title: {
        color: "",
      },
      subtitle: {
        color: "",
      },
      cardHeader: {
        color: "",
      },
      featureName: {},
      featureValue: {
        color: "",
      },
      buttonCard: {
        backgroundColor: "",
        color: "",
      },
      hoverButtonCard: {
        color: "",
        backgroundColor: "",
      },
      iconCard: {
        color: "",
      },
      btnDirectPlan: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      circularColor: {
        color: "",
      },
      tablePlanTable: {
        color: "",
        backgroundColor: "",
        fontWeight: "",
      },
      tableCellPlanTable: {
        color: "",
        backgroundColor: "",
      },
      purchasedPlans: {
        color: "",
        fontWeight: "",
      },
      plansTypography: {
        color: "",
        marginLeft: 0,
      },
      spanPlanTable: {
        color: "",
      },
      reportIcon: {
        color: "",
      },
    },
    passwordCheckColor:{
      borderInput: "#455C79"
    }
  },
  license_pancert: {
    tenantLanguage: "es",
    primary: {
      light: "#1E1A34",
      main: "#0059AD",
      dark: "#003582",
      iconSend: "#003582",
    },
    secondary: {
      dark: "#E45501",
      main: "rgba(52, 73, 94, 1)",
      light: "#ffffff",
      titleText: "#121F43"
    },
    info: {
      light: "#335474",
      main: "#00000080",
      dark: "#C1C1C1",
    },
    error: {
      light: "#FF316F",
      main: "#FF316F1A",
      dark: "#FF316F",
      secondary: "",
      typographyColor: "#FF316F"
    },
    background: {
      paper: "#ffffff",   // fondo de las cards
      input: "",
      adornmentPrimary: "",
      selectColorDefault: "#E6FBF8",
      selectUsersCertificates: "",
      adornmentSecondary: "",
      certificateButtonColor: "",
      selectIcon: "#047763",
      disabledButtonColor: "",
      backButtonColor: "",
      codeInputBorderColor: "",
      hr:""
    },
    letter: {
      color: "#163357",
      disabledColor: "",
      typographyColor: "",
      codeInputTypographyColor: ""
    },
    logoSettings: {
      widthResendEmail: "",
      heightResendEmail: "80px",
      marginLeftResendEmail: "",
      widthResetPwd: "",
      heightAlertResetPassword: "",
      heightResetPassword: "",
      marginLeftResetPassword: "",
      widthImage: "80px",
    },
    urlLogo: {
      url: "LogosUko//letmicert/Letmi_login.png",
      urlSignIn: "LogosUko//letmicert/Letmicert_logo.svg",
      urlRememberPasswordlogo: "LogosUko//letmicert/RememberPasswordUko.png",
      urlCheckEmaillogo: "LogosUko//letmicert/SendEmail.png",
      urlCheckEmailMoreBlue: "LogosUko//letmicert/Mail_Icon.svg",
      urlInvalidLinkMoreBlue: "LogosUko//letmicert/InvalidLinkMoreBlue.png",
      urlRemeberAndInvalid: "LogosUko//myselfcert/RememberPasswordInvalidUrl.png",
      urlExpireTime: "LogosUko//letmicert/ExpireTime.png",
      urlChangePasswordlogo: "LogosUko//letmicert/ChangePassword.png",
      urlActivatePasswordlogo: "LogosUko//letmicert/ActivatePassword.png",
      urlSuccessAlertlogo: "LogosUko//letmicert/PasswordUpdated.png",
      urlSuccessAccountActivated:"LogosUko//letmicert/PasswordUpdated.png",
      urlCheckEmailAgain: "LogosUko//letmicert/CheckEmailAgain.png",
      urlMaintenanceImage: "myselfcert/maintenanceImage.png",
      urlWhiteGseLogo: "myselfcert/whiteGseLogo.png",
      urlPasswordResetLogo: "",
      urlResendEmailLogo: "letmicertLogo.svg",
      urlAlert: "letmicertLogo.svg",
    },
    InputUko: {
      colorInputLetter: "#011E3D",
      borderInput: "#455C79",
      colorLabel: "#738499",
      colorLabelFocus: "#163357",
      colorIcon: "#455C79",
      backgroundColor: "#FFFFFF"
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "#F2F6FA",
      buttonUkoColorDisabled: "#B0CCE6",
      buttonUkoBackgroundActive: "#0059AD",
      buttonUkoBackgroundSuccess: "#FFFFFF",
      buttonUkoColorDisabledResetPwd: "",
    },
    linkUko: {
      colorLink: "#163357",
    },
    typographyMessageUko: {
      textColor: '#163357',
    },
    versionUko: {
      colorVersionLabel: "#335474"
    },
    alertUko: {
      imageUko: "LogosUko//letmicert/InfoIcon.svg",
      colorTextUko: "#163357",
    },
    forgotPassword: {
      colorForgotPwd: "",
    },
    typographyText:{
      textColor: '#163357',
      pathColor: '#FFFFFF'
    },
    selectAccount: {
      colorRoot: "",
      colorChecked: "",
    },
    widthImageLogo: "200px",
    colorLoading:"#2499EF",
    errorBox: {
      color: "",
      backgroundColor: "",
    },
    statusLicense: {
      containerMessage: {
        backgroundColor: "",
      },
    },
    alertPopup: {
      iconClose: {
        color: "",
      },
      titleAlert: {
        color: "",
      },
      buttonCancel: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      buttonAccept: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      secondaryMessageText: {
        color: "",
      },
      mensajeModalMain: {},
    },
    iconColorError: {
      bgColorCards: {},
      appBgColorCards: {
        boxShadow: "",
      },
      rootCard: {},
      title: {
        color: "",
      },
      subtitle: {
        color: "",
      },
      cardHeader: {
        color: "",
      },
      featureName: {},
      featureValue: {
        color: "",
      },
      buttonCard: {
        backgroundColor: "",
        color: "",
      },
      hoverButtonCard: {
        color: "",
        backgroundColor: "",
      },
      iconCard: {
        color: "",
      },
      btnDirectPlan: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      circularColor: {
        color: "",
      },
      tablePlanTable: {
        color: "",
        backgroundColor: "",
        fontWeight: "",
      },
      tableCellPlanTable: {
        color: "",
        backgroundColor: "",
      },
      purchasedPlans: {
        color: "",
        fontWeight: "",
      },
      plansTypography: {
        color: "",
        marginLeft: 0,
      },
      spanPlanTable: {
        color: "",
      },
      reportIcon: {
        color: "",
      },
    },
    passwordCheckColor:{
      borderInput: "#455C79"
    }
  },
  license_myselfcert: {
    tenantLanguage: "es",
    primary: {
      light: "#009BDD",
      main: "#1D71B8",
      dark: "#003582",
      iconSend: "#003582",
    },
    secondary: {
      dark: "#E45501",
      main: "#FF0004",
      light: "#FFE5E6",
      titleText: "#003582",
    },
    info: {
      light: "#D5D5D5",
      main: "#00000080",
      dark: "#C1C1C1",
    },
    error: {
      light: "#FA5A00",
      main: "#D80000",
      dark: "#D80000",
      secondary: "",
    },
    background: {
      paper: "#ffffff",   // fondo de las cards
      input: "",
      adornmentPrimary: "",
      selectColorDefault: "#E6FFEF",
      selectUsersCertificates: "",
      adornmentSecondary: "",
      certificateButtonColor: "",
      selectIcon: "#007C2F",
      disabledButtonColor: "",
      backButtonColor: "",
      codeInputBorderColor: "",
      hr:""
    },
    letter: {
      color: "",
      disabledColor: "",
      typographyColor: "",
      codeInputTypographyColor: ""
    },
    logoSettings: {
      widthResendEmail: "",
      heightResendEmail: "",
      marginLeftResendEmail: "",
      widthResetPwd: "",
      heightAlertResetPassword: "",
      heightResetPassword: "",
      marginLeftResetPassword: "",
      widthImage: "306px",
    },
    urlLogo: {
      url: "",
      urlSignIn: "",
      urlRememberPasswordlogo: "",
      urlCheckEmaillogo: "",
      urlCheckEmailMoreBlue: "",
      urlInvalidLinkMoreBlue: "",
      urlRemeberAndInvalid: "",
      urlExpireTime: "",
      urlChangePasswordlogo: "",
      urlActivatePasswordlogo: "",
      urlSuccessAlertlogo: "",
      urlSuccessAccountActivated:"",
      urlCheckEmailAgain: "",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
      urlPasswordResetLogo: "",
      urlResendEmailLogo: "",
      urlAlert: "",
    },
    InputUko: {
      colorInputLetter: "",
      borderInput: "",
      colorLabel: "",
      colorLabelFocus: "",
      colorIcon: "",
      backgroundColor: "",
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "#D1E2F0",
      buttonUkoColorDisabled: "#FFFFFF",
      buttonUkoBackgroundActive: "",
      buttonUkoBackgroundSuccess: "",
      buttonUkoColorDisabledResetPwd: "",
    },
    linkUko: {
      colorLink: "",
    },
    typographyMessageUko: {
      textColor: '',
    },
    versionUko: {
      colorVersionLabel: ""
    },
    alertUko: {
      imageUko: "",
      colorTextUko: "",
    },
    forgotPassword: {
      colorForgotPwd: "",
    },
    typographyText:{
      textColor: '#738499',
      pathColor: '#FFFFFF'
    },
    selectAccount: {
      colorRoot: "",
      colorChecked: "",
    },
    widthImageLogo: "",
    colorLoading:"#1D71B8",
    errorBox: {
      color: "",
      backgroundColor: "",
    },
    statusLicense: {
      containerMessage: {
        backgroundColor: "",
      },
    },
    alertPopup: {
      iconClose: {
        color: "",
      },
      titleAlert: {
        color: "",
      },
      buttonCancel: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      buttonAccept: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      secondaryMessageText: {
        color: "",
      },
      mensajeModalMain: {},
    },
    iconColorError: {
      bgColorCards: {},
      appBgColorCards: {
        boxShadow: "",
      },
      rootCard: {},
      title: {
        color: "",
      },
      subtitle: {
        color: "",
      },
      cardHeader: {
        color: "",
      },
      featureName: {},
      featureValue: {
        color: "",
      },
      buttonCard: {
        backgroundColor: "",
        color: "",
      },
      hoverButtonCard: {
        color: "",
        backgroundColor: "",
      },
      iconCard: {
        color: "",
      },
      btnDirectPlan: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      circularColor: {
        color: "",
      },
      tablePlanTable: {
        color: "",
        backgroundColor: "",
        fontWeight: "",
      },
      tableCellPlanTable: {
        color: "",
        backgroundColor: "",
      },
      purchasedPlans: {
        color: "",
        fontWeight: "",
      },
      plansTypography: {
        color: "",
        marginLeft: 0,
      },
      spanPlanTable: {
        color: "",
      },
      reportIcon: {
        color: "",
      },
    },
    passwordCheckColor:{
      borderInput: ""
    }
  },
  lstinhib: {
    tenantLanguage: "es",
    primary: {
      light: "#CCFFF6",
      main: "#00CCA7",
      dark: "#003582",
      iconSend: "#003582",
    },
    secondary: {
      dark: "#E45501",
      main: "rgba(52, 73, 94, 1)",
      light: "#FFFFFF",
      titleText: "#121F43"
    },
    info: {
      light: "#335474",
      main: "#00000080",
      dark: "#C1C1C1",
    },
    error: {
      light: "#FF316F",
      main: "#FF316F1A",
      dark: "#FF316F",
      secondary: "",
      typographyColor: "#FF316F"
    },
    background: {
      paper: "#ffffff",   // fondo de las cards
      input: "",
      adornmentPrimary: "",
      selectColorDefault: "#E6FFEF",
      selectUsersCertificates: "",
      adornmentSecondary: "",
      certificateButtonColor: "",
      selectIcon: "#007C2F",
      disabledButtonColor: "",
      backButtonColor: "",
      codeInputBorderColor: "",
      hr:""
    },
    letter: {
      color: "",
      disabledColor: "",
      typographyColor: "",
      codeInputTypographyColor: ""
    },
    logoSettings: {
      widthResendEmail: "",
      heightResendEmail: "",
      marginLeftResendEmail: "",
      widthResetPwd: "115px",
      heightAlertResetPassword: "",
      heightResetPassword: "",
      marginLeftResetPassword: "",
      widthImage: "",
    },
    urlLogo: {
      url: "LogosUko/lstinhib/gse/LoginUko.png",
      urlSignIn: "LogosUko//lstinhib/gse/LogoSignInUko.png",
      urlRememberPasswordlogo: "LogosUko//lstinhib/gse/RememberPasswordUko.png",
      urlCheckEmaillogo: "LogosUko//lstinhib/gse/CheckEmail.png",
      urlCheckEmailMoreBlue: "LogosUko//lstinhib/gse/CheckEmailMoreBlue.png",
      urlInvalidLinkMoreBlue: "LogosUko//lstinhib/gse/InvalidLinkMoreBlue.png",
      urlRemeberAndInvalid: "LogosUko//lstinhib/gse/RememberPasswordInvalidUrl.png",
      urlExpireTime: "LogosUko//lstinhib/gse/ExpireTime.png",
      urlChangePasswordlogo: "LogosUko//lstinhib/gse/ChangePassword.png",
      urlActivatePasswordlogo: "LogosUko//lstinhib/gse/ChangePassword.png",
      urlSuccessAlertlogo: "LogosUko//lstinhib/gse/PasswordUpdated.png",
      urlSuccessAccountActivated:"LogosUko//lstinhib/gse/PasswordUpdated.png",
      urlCheckEmailAgain: "LogosUko//lstinhib/gse/CheckEmailAgain.png",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
      urlPasswordResetLogo: "",
      urlResendEmailLogo: "LogosUko//lstinhib/gse/LogoSignInUko.png",
      urlAlert: "LogosUko//lstinhib/gse/LogoSignInUko.png",
    },
    InputUko: {
      colorInputLetter: "#011E3D",
      borderInput: "#738499",
      colorLabel: "#738499",
      colorLabelFocus: "#00CCA7",
      colorIcon: "#738499",
      backgroundColor: "#FFFFFF"
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "#DCE5F0",
      buttonUkoColorDisabled: "#9CA3AF",
      buttonUkoBackgroundActive: "#00CCA7",
      buttonUkoBackgroundSuccess: "#0A0C0D",
      buttonUkoColorDisabledResetPwd: "",
    },
    linkUko: {
      colorLink: "#202427",
    },
    typographyMessageUko: {
      textColor: '#335474',
    },
    versionUko: {
      colorVersionLabel: "#335474"
    },
    alertUko: {
      imageUko: "LogosUko//lstinhib/gse/alertUko.png",
      colorTextUko: "#335474",
    },
    forgotPassword: {
      colorForgotPwd: "",
    },
    typographyText:{
      textColor: '#738499',
      pathColor: '#FFFFFF'
    },
    selectAccount: {
      colorRoot: "",
      colorChecked: "",
    },
    widthImageLogo: "115.71px",
    colorLoading:"",
    errorBox: {
      color: "",
      backgroundColor: "",
    },
    statusLicense: {
      containerMessage: {
        backgroundColor: "",
      },
    },
    alertPopup: {
      iconClose: {
        color: "",
      },
      titleAlert: {
        color: "",
      },
      buttonCancel: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      buttonAccept: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      secondaryMessageText: {
        color: "",
      },
      mensajeModalMain: {},
    },
    iconColorError: {
      bgColorCards: {},
      appBgColorCards: {
        boxShadow: "",
      },
      rootCard: {},
      title: {
        color: "",
      },
      subtitle: {
        color: "",
      },
      cardHeader: {
        color: "",
      },
      featureName: {},
      featureValue: {
        color: "",
      },
      buttonCard: {
        backgroundColor: "",
        color: "",
      },
      hoverButtonCard: {
        color: "",
        backgroundColor: "",
      },
      iconCard: {
        color: "",
      },
      btnDirectPlan: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      circularColor: {
        color: "",
      },
      tablePlanTable: {
        color: "",
        backgroundColor: "",
        fontWeight: "",
      },
      tableCellPlanTable: {
        color: "",
        backgroundColor: "",
      },
      purchasedPlans: {
        color: "",
        fontWeight: "",
      },
      plansTypography: {
        color: "",
        marginLeft: 0,
      },
      spanPlanTable: {
        color: "",
      },
      reportIcon: {
        color: "",
      },
    },
    passwordCheckColor:{
      borderInput: "#738499"
    }
  },
  lstinhib_gse: {
    tenantLanguage: "es",
    primary: {
      light: "#CCFFF6",
      main: "#00CCA7",
      dark: "#003582",
      iconSend: "#003582",
    },
    secondary: {
      dark: "#E45501",
      main: "rgba(52, 73, 94, 1)",
      light: "#FFFFFF",
      titleText: "#0A0C0D"
    },
    info: {
      light: "#335474",
      main: "#00000080",
      dark: "#C1C1C1",
    },
    error: {
      light: "#FF316F",
      main: "#FF316F1A",
      dark: "#FF316F",
      secondary: "",
      typographyColor: "#FF316F"
    },
    background: {
      paper: "#ffffff",   // fondo de las cards
      input: "",
      adornmentPrimary: "",
      selectColorDefault: "#27CE881A",
      selectUsersCertificates: "",
      adornmentSecondary: "",
      certificateButtonColor: "",
      selectIcon: "#1D9C67",
      disabledButtonColor: "",
      backButtonColor: "",
      codeInputBorderColor: "",
      hr:""
    },
    letter: {
      color: "",
      disabledColor: "",
      typographyColor: "",
      codeInputTypographyColor: ""
    },
    logoSettings: {
      widthResendEmail: "",
      heightResendEmail: "",
      marginLeftResendEmail: "",
      widthResetPwd: "115px",
      heightAlertResetPassword: "",
      heightResetPassword: "",
      marginLeftResetPassword: "",
      widthImage: "306px",
    },
    urlLogo: {
      url: "LogosUko/lstinhib/gse/LoginUko.png",
      urlSignIn: "LogosUko//lstinhib/gse/LogoSignInUko.png",
      urlRememberPasswordlogo: "LogosUko//lstinhib/gse/RememberPasswordUko.png",
      urlCheckEmaillogo: "LogosUko//lstinhib/gse/CheckEmail.png",
      urlCheckEmailMoreBlue: "LogosUko//lstinhib/gse/CheckEmailMoreBlue.png",
      urlInvalidLinkMoreBlue: "LogosUko//lstinhib/gse/InvalidLinkMoreBlue.png",
      urlRemeberAndInvalid: "LogosUko//lstinhib/gse/RememberPasswordInvalidUrl.png",
      urlExpireTime: "LogosUko//lstinhib/gse/ExpireTime.png",
      urlChangePasswordlogo: "LogosUko//lstinhib/gse/ChangePassword.png",
      urlActivatePasswordlogo: "LogosUko//lstinhib/gse/ChangePassword.png",
      urlSuccessAlertlogo: "LogosUko//lstinhib/gse/PasswordUpdated.png",
      urlSuccessAccountActivated:"LogosUko//lstinhib/gse/PasswordUpdated.png",
      urlCheckEmailAgain: "LogosUko//lstinhib/gse/CheckEmailAgain.png",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
      urlPasswordResetLogo: "",
      urlResendEmailLogo: "LogosUko//lstinhib/gse/LogoSignInUko.png",
      urlAlert: "LogosUko//lstinhib/gse/LogoSignInUko.png",
    },
    InputUko: {
      colorInputLetter: "#011E3D",
      borderInput: "#738499",
      colorLabel: "#738499",
      colorLabelFocus: "#00CCA7",
      colorIcon: "#738499",
      backgroundColor: "#FFFFFF"
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "#DCE5F0",
      buttonUkoColorDisabled: "#9CA3AF",
      buttonUkoBackgroundActive: "#00CCA7",
      buttonUkoBackgroundSuccess: "#0A0C0D",
      buttonUkoColorDisabledResetPwd: "",
    },
    linkUko: {
      colorLink: "#202427",
    },
    typographyMessageUko: {
      textColor: '#335474',
    },
    versionUko: {
      colorVersionLabel: "#335474"
    },
    alertUko: {
      imageUko: "LogosUko//lstinhib/gse/alertUko.png",
      colorTextUko: "#335474",
    },
    forgotPassword: {
      colorForgotPwd: "",
    },
    typographyText:{
      textColor: '#738499',
      pathColor: '#FFFFFF'
    },
    selectAccount: {
      colorRoot: "",
      colorChecked: "",
    },
    widthImageLogo: "115.71px",
    colorLoading:"",
    errorBox: {
      color: "",
      backgroundColor: "",
    },
    statusLicense: {
      containerMessage: {
        backgroundColor: "",
      },
    },
    alertPopup: {
      iconClose: {
        color: "",
      },
      titleAlert: {
        color: "",
      },
      buttonCancel: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      buttonAccept: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      secondaryMessageText: {
        color: "",
      },
      mensajeModalMain: {},
    },
    iconColorError: {
      bgColorCards: {},
      appBgColorCards: {
        boxShadow: "",
      },
      rootCard: {},
      title: {
        color: "",
      },
      subtitle: {
        color: "",
      },
      cardHeader: {
        color: "",
      },
      featureName: {},
      featureValue: {
        color: "",
      },
      buttonCard: {
        backgroundColor: "",
        color: "",
      },
      hoverButtonCard: {
        color: "",
        backgroundColor: "",
      },
      iconCard: {
        color: "",
      },
      btnDirectPlan: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      circularColor: {
        color: "",
      },
      tablePlanTable: {
        color: "",
        backgroundColor: "",
        fontWeight: "",
      },
      tableCellPlanTable: {
        color: "",
        backgroundColor: "",
      },
      purchasedPlans: {
        color: "",
        fontWeight: "",
      },
      plansTypography: {
        color: "",
        marginLeft: 0,
      },
      spanPlanTable: {
        color: "",
      },
      reportIcon: {
        color: "",
      },
    },
    passwordCheckColor:{
      borderInput: "#738499"
    }
  },
  lstinhib_paynet: {
    tenantLanguage: "es",
    primary: {
      light: "#F6F6F6",
      main: "#4433F8",
      dark: "#003582",
      iconSend: "#003582",
    },
    secondary: {
      dark: "#E45501",
      main: "rgba(52, 73, 94, 1)",
      light: "#FFFFFF",
      titleText: "#121F43"
    },
    info: {
      light: "#335474",
      main: "#00000080",
      dark: "#C1C1C1",
    },
    error: {
      light: "#FF316F",
      main: "#FF316F1A",
      dark: "#FF316F",
      secondary: "",
      typographyColor: "#FF316F"
    },
    background: {
      paper: "#ffffff",   // fondo de las cards
      input: "",
      adornmentPrimary: "",
      selectColorDefault: "#27CE881A",
      selectUsersCertificates: "",
      adornmentSecondary: "",
      certificateButtonColor: "",
      selectIcon: "#1D9C67",
      disabledButtonColor: "",
      backButtonColor: "",
      codeInputBorderColor: "",
      hr:""
    },
    letter: {
      color: "",
      disabledColor: "",
      typographyColor: "",
      codeInputTypographyColor: ""
    },
    logoSettings: {
      widthResendEmail: "",
      heightResendEmail: "",
      marginLeftResendEmail: "",
      widthResetPwd: "115px",
      heightAlertResetPassword: "",
      heightResetPassword: "",
      marginLeftResetPassword: "",
      widthImage: "306px",
    },
    urlLogo: {
      url: "LogosUko/lstinhib/paynet/LoginUko.png",
      urlSignIn: "LogosUko//lstinhib/paynet/LogoSignInUko.png",
      urlRememberPasswordlogo: "LogosUko//lstinhib/paynet/RememberPasswordUko.png",
      urlCheckEmaillogo: "LogosUko//lstinhib/paynet/CheckEmail.png",
      urlCheckEmailMoreBlue: "LogosUko//lstinhib/paynet/CheckEmailMoreBlue.png",
      urlInvalidLinkMoreBlue: "LogosUko//lstinhib/paynet/InvalidLinkMoreBlue.png",
      urlRemeberAndInvalid: "LogosUko//lstinhib/paynet/RememberPasswordInvalidUrl.png",
      urlExpireTime: "LogosUko//lstinhib/paynet/ExpireTime.png",
      urlChangePasswordlogo: "LogosUko//lstinhib/paynet/ChangePassword.png",
      urlActivatePasswordlogo: "LogosUko//lstinhib/paynet/ChangePassword.png",
      urlSuccessAlertlogo: "LogosUko//lstinhib/paynet/PasswordUpdated.png",
      urlSuccessAccountActivated:"LogosUko//lstinhib/paynet/PasswordUpdated.png",
      urlCheckEmailAgain: "LogosUko//lstinhib/paynet/CheckEmailAgain.png",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
      urlPasswordResetLogo: "",
      urlResendEmailLogo: "LogosUko//lstinhib/paynet/LogoSignInUko.png",
      urlAlert: "LogosUko//lstinhib/paynet/LogoSignInUko.png",
    },
    InputUko: {
      colorInputLetter: "#011E3D",
      borderInput: "#738499",
      colorLabel: "#738499",
      colorLabelFocus: "#4433F8",
      colorIcon: "#738499",
      backgroundColor: "#FFFFFF"
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "#DCE5F0",
      buttonUkoColorDisabled: "#9CA3AF",
      buttonUkoBackgroundActive: "#CC0024",
      buttonUkoBackgroundSuccess: "#FFFFFF",
      buttonUkoColorDisabledResetPwd: "",
    },
    linkUko: {
      colorLink: "#202427",
    },
    typographyMessageUko: {
      textColor: '#335474',
    },
    versionUko: {
      colorVersionLabel: "#335474"
    },
    alertUko: {
      imageUko: "LogosUko//lstinhib/paynet/alertUko.png",
      colorTextUko: "#335474",
    },
    forgotPassword: {
      colorForgotPwd: "",
    },
    typographyText:{
      textColor: '#738499',
      pathColor: '#FFFFFF'
    },
    selectAccount: {
      colorRoot: "",
      colorChecked: "",
    },
    widthImageLogo: "162px",
    colorLoading:"",
    errorBox: {
      color: "",
      backgroundColor: "",
    },
    statusLicense: {
      containerMessage: {
        backgroundColor: "",
      },
    },
    alertPopup: {
      iconClose: {
        color: "",
      },
      titleAlert: {
        color: "",
      },
      buttonCancel: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      buttonAccept: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      secondaryMessageText: {
        color: "",
      },
      mensajeModalMain: {},
    },
    iconColorError: {
      bgColorCards: {},
      appBgColorCards: {
        boxShadow: "",
      },
      rootCard: {},
      title: {
        color: "",
      },
      subtitle: {
        color: "",
      },
      cardHeader: {
        color: "",
      },
      featureName: {},
      featureValue: {
        color: "",
      },
      buttonCard: {
        backgroundColor: "",
        color: "",
      },
      hoverButtonCard: {
        color: "",
        backgroundColor: "",
      },
      iconCard: {
        color: "",
      },
      btnDirectPlan: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      circularColor: {
        color: "",
      },
      tablePlanTable: {
        color: "",
        backgroundColor: "",
        fontWeight: "",
      },
      tableCellPlanTable: {
        color: "",
        backgroundColor: "",
      },
      purchasedPlans: {
        color: "",
        fontWeight: "",
      },
      plansTypography: {
        color: "",
        marginLeft: 0,
      },
      spanPlanTable: {
        color: "",
      },
      reportIcon: {
        color: "",
      },
    },
    passwordCheckColor:{
      borderInput: "#738499"
    }
  },
  projectk: {
    tenantLanguage: "es",
    primary: {
      light: "#FFF0D3",
      main: "#4FBAFF",
      dark: "#003582",
      iconSend: "#003582",
    },
    secondary: {
      dark: "#E45501",
      main: "rgba(52, 73, 94, 1)",
      light: "#FCFBF7",
      titleText: "#121F43"
    },
    info: {
      light: "#0F0F0F",
      main: "#00000080",
      dark: "#C1C1C1",
    },
    error: {
      light: "#DC2626",
      main: "#FCE9E9",
      dark: "#FF316F",
      secondary: "",
      typographyColor: "#DC2626"
    },
    background: {
      paper: "#ffffff",   // fondo de las cards
      input: "",
      adornmentPrimary: "",
      selectColorDefault: "#27CE881A",
      selectUsersCertificates: "",
      adornmentSecondary: "",
      certificateButtonColor: "",
      selectIcon: "#1D9C67",
      disabledButtonColor: "",
      backButtonColor: "",
      codeInputBorderColor: "",
      hr:""
    },
    letter: {
      color: "#C24502",
      disabledColor: "",
      typographyColor: "",
      codeInputTypographyColor: ""
    },
    logoSettings: {
      widthResendEmail: "225px",
      heightResendEmail: "80px",
      marginLeftResendEmail: "",
      widthResetPwd: "146px",
      heightResetPassword: "",
      heightAlertResetPassword: "",
      marginLeftResetPassword: "",
      widthImage: "",
    },
    urlLogo: {
      url: "LogosUko/projectk/taxiLogin.png",
      urlSignIn: "LogosUko/projectk/CalesasLogo.svg",
      urlRememberPasswordlogo: "LogosUko/projectk/RememberPasswordUko.svg",
      urlCheckEmaillogo: "LogosUko/projectk/SendEmail2.svg",
      urlCheckEmailMoreBlue: "LogosUko/letmicert/Mail_Icon.svg",
      urlInvalidLinkMoreBlue: "LogosUko/letmicert/Break_icon.svg",
      urlRemeberAndInvalid: "LogosUko//lstinhib/paynet/RememberPasswordInvalidUrl.png",
      urlExpireTime: "LogosUko/letmicert/Alert_Icon.svg",
      urlChangePasswordlogo: "LogosUko/projectk/ChangePassword.svg",
      urlActivatePasswordlogo: "LogosUko/projectk/ActivateUser.svg",
      urlSuccessAlertlogo: "LogosUko/projectk/UserActive.svg",
      urlSuccessAccountActivated:"LogosUko/projectk/UserActive.svg",
      urlCheckEmailAgain: "LogosUko/letmicert/Mail_Icon.svg",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
      urlPasswordResetLogo: "",
      urlResendEmailLogo: "LogosUko/projectk/CalesasLogo.svg",
      urlAlert: "LogosUko/projectk/CalesasLogo.svg",
    },
    InputUko: {
      colorInputLetter: "#0F0F0F",
      borderInput: "#3B3B3B",
      colorLabel: "#738499",
      colorLabelFocus: "#4FBAFF",
      colorIcon: "#000",
      backgroundColor: "#fdfcfc"
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "#F6F5F0",
      buttonUkoColorDisabled: "#A6A6A6",
      buttonUkoBackgroundActive: "#FF944F",
      buttonUkoBackgroundSuccess: "#0F0F0F",
      buttonUkoColorDisabledResetPwd: "",
    },
    linkUko: {
      colorLink: "#C24502",
    },
    typographyMessageUko: {
      textColor: '#0F0F0F',
    },
    versionUko: {
      colorVersionLabel: "#0F0F0F"
    },
    alertUko: {
      imageUko: "LogosUko//letmicert/InfoIcon.svg",
      colorTextUko: "#0F0F0F",
    },
    forgotPassword: {
      colorForgotPwd: "",
    },
    typographyText:{
      textColor: '#3B3B3B',
      pathColor: '#0F0F0F'
    },
    selectAccount: {
      colorRoot: "",
      colorChecked: "",
    },
    widthImageLogo: "146px",
    colorLoading:"",
    errorBox: {
      color: "",
      backgroundColor: "",
    },
    statusLicense: {
      containerMessage: {
        backgroundColor: "",
      },
    },
    alertPopup: {
      iconClose: {
        color: "",
      },
      titleAlert: {
        color: "",
      },
      buttonCancel: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      buttonAccept: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      secondaryMessageText: {
        color: "",
      },
      mensajeModalMain: {},
    },
    iconColorError: {
      bgColorCards: {},
      appBgColorCards: {
        boxShadow: "",
      },
      rootCard: {},
      title: {
        color: "",
      },
      subtitle: {
        color: "",
      },
      cardHeader: {
        color: "",
      },
      featureName: {},
      featureValue: {
        color: "",
      },
      buttonCard: {
        backgroundColor: "",
        color: "",
      },
      hoverButtonCard: {
        color: "",
        backgroundColor: "",
      },
      iconCard: {
        color: "",
      },
      btnDirectPlan: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      circularColor: {
        color: "",
      },
      tablePlanTable: {
        color: "",
        backgroundColor: "",
        fontWeight: "",
      },
      tableCellPlanTable: {
        color: "",
        backgroundColor: "",
      },
      purchasedPlans: {
        color: "",
        fontWeight: "",
      },
      plansTypography: {
        color: "",
        marginLeft: 0,
      },
      spanPlanTable: {
        color: "",
      },
      reportIcon: {
        color: "",
      },
    },
    passwordCheckColor:{
      borderInput: "#3B3B3B"
    }
  },
  colfactura_cfweb: {
    tenantLanguage: "es",
    primary: {
      light: "#FAFAFA",
      main: "#0095CE",
      dark: "#003582",
      iconSend: "#003582",
    },
    secondary: {
      dark: "#E45501",
      main: "rgba(52, 73, 94, 1)",
      light: "#FFFFFF",
      titleText: "#0F0F0F"
    },
    info: {
      light: "#0F0F0F",
      main: "#00000080",
      dark: "#C1C1C1",
    },
    error: {
      light: "#DC2626",
      main: "#FCE9E9",
      dark: "#FF316F",
      secondary: "",
      typographyColor: "#C82323"
    },
    background: {
      paper: "#ffffff",   // fondo de las cards
      input: "",
      adornmentPrimary: "",
      selectColorDefault: "#27CE881A",
      selectUsersCertificates: "",
      adornmentSecondary: "",
      certificateButtonColor: "",
      selectIcon: "#1D9C67",
      disabledButtonColor: "",
      backButtonColor: "",
      codeInputBorderColor: "",
      hr:""
    },
    letter: {
      color: "#006FC3",
      disabledColor: "",
      typographyColor: "",
      codeInputTypographyColor: ""
    },
    logoSettings: {
      widthResendEmail: "225px",
      heightResendEmail: "80px",
      marginLeftResendEmail: "",
      widthResetPwd: "192px",
      heightAlertResetPassword: "",
      heightResetPassword: "",
      marginLeftResetPassword: "",
      widthImage: "",
    },
    urlLogo: {
      url: "LogosUko/myselfcert/LoginUko.png",
      urlSignIn: "LogosUko/newColfactura/logo.svg",
      urlRememberPasswordlogo: "LogosUko/myselfcert/RememberPasswordUko.png",
      urlCheckEmaillogo: "LogosUko/myselfcert/CheckEmail.svg",
      urlCheckEmailMoreBlue: "LogosUko/letmicert/Mail_Icon.svg",
      urlInvalidLinkMoreBlue: "LogosUko/letmicert/Break_icon.svg",
      urlRemeberAndInvalid: "LogosUko/myselfcert/RememberPasswordInvalidUrl.png",
      urlExpireTime: "LogosUko/letmicert/Alert_Icon.svg",
      urlChangePasswordlogo: "LogosUko/myselfcert/ChangePassword.png",
      urlActivatePasswordlogo: "LogosUko/myselfcert/activateAccount.svg",
      urlSuccessAlertlogo: "LogosUko/myselfcert/PasswordUpdated.png",
      urlSuccessAccountActivated:"LogosUko/myselfcert/PasswordUpdated.png",
      urlCheckEmailAgain: "LogosUko/letmicert/Mail_Icon.svg",
      urlMaintenanceImage: "maintenanceImage.png",
      urlWhiteGseLogo: "whiteGseLogo.png",
      urlPasswordResetLogo: "",
      urlResendEmailLogo: "LogosUko/newColfactura/logo.svg",
      urlAlert: "LogosUko/newColfactura/logo.svg",
    },
    InputUko: {
      colorInputLetter: "#0F0F0F",
      borderInput: "#A6A6A6",
      colorLabel: "#A6A6A6",
      colorLabelFocus: "#0095CE",
      colorIcon: "#000",
      backgroundColor: "#fdfcfc"
    },
    buttonUko: {
      buttonUkoBackgroundDisabled: "#E5E5E5",
      buttonUkoColorDisabled: "#A6A6A6",
      buttonUkoBackgroundActive: "#06B4EA",
      buttonUkoBackgroundSuccess: "#0F0F0F",
      buttonUkoColorDisabledResetPwd: "",
    },
    linkUko: {
      colorLink: "#006FC3",
    },
    typographyMessageUko: {
      textColor: '#212121',
    },
    versionUko: {
      colorVersionLabel: "#0F0F0F"
    },
    alertUko: {
      imageUko: "LogosUko//letmicert/InfoIcon.svg",
      colorTextUko: "#0F0F0F",
    },
    forgotPassword: {
      colorForgotPwd: "",
    },
    typographyText:{
      textColor: '#3B3B3B',
      pathColor: '#0F0F0F'
    },
    selectAccount: {
      colorRoot: "",
      colorChecked: "",
    },
    widthImageLogo: "192px",
    colorLoading:"",
    errorBox: {
      color: "",
      backgroundColor: "",
    },
    statusLicense: {
      containerMessage: {
        backgroundColor: "",
      },
    },
    alertPopup: {
      iconClose: {
        color: "#545454",
      },
      titleAlert: {
        color: "",
      },
      buttonCancel: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      buttonAccept: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      secondaryMessageText: {
        color: "",
      },
      mensajeModalMain: {},
    },
    iconColorError: {
      bgColorCards: {},
      appBgColorCards: {
        boxShadow: "",
      },
      rootCard: {},
      title: {
        color: "",
      },
      subtitle: {
        color: "",
      },
      cardHeader: {
        color: "",
      },
      featureName: {},
      featureValue: {
        color: "",
      },
      buttonCard: {
        backgroundColor: "",
        color: "",
      },
      hoverButtonCard: {
        color: "",
        backgroundColor: "",
      },
      iconCard: {
        color: "",
      },
      btnDirectPlan: {
        backgroundColor: "",
        color: "",
        '&:hover': {
          backgroundColor: "",
        },
      },
      circularColor: {
        color: "",
      },
      tablePlanTable: {
        color: "",
        backgroundColor: "",
        fontWeight: "",
      },
      tableCellPlanTable: {
        color: "",
        backgroundColor: "",
      },
      purchasedPlans: {
        color: "",
        fontWeight: "",
      },
      plansTypography: {
        color: "",
        marginLeft: 0,
      },
      spanPlanTable: {
        color: "",
      },
      reportIcon: {
        color: "",
      },
    },
    passwordCheckColor:{
      borderInput: "#A6A6A6"
    }
  }
};

/*
  primary -> light: #009BDD / main: #1D71B8  / dark: #003582
  secondary -> light: #FA5A00  / main: #FA5A00  / dark:  #E45501
  error -> light:  / main:  / dark:
  warning -> light:  / main:  / dark:
  info -> light:  #00000026 / main: #00000080 / dark:  #00000099
  success -> light:  / main:  / dark:
 */
